import React, { useState, useEffect } from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import Config from '../../config/env';
import API from '../../utils/apiCalling';
import Loader from '../../utils/loader';
import { useParams } from 'react-router-dom/cjs/react-router-dom';

const QuotaSheet = () => {
  const [dashboardData, setDashboardData] = useState([]);
  const [allQuestions, setAllQuestions] = useState([]);
  const [loader, setLoader] = useState(false);
  const [selectedDate, setSelectedDate] = useState('');
  const [surveyId, setSurveyId] = useState(null);
  const checkarray = ['Select the city?','Select shop/business  type',]
  const id = useParams();

  let api = new API();

  useEffect(() => {
    getSurveyById(id)
  
  }, []);

  const handleDateChange = (e) => {
    const newDate = e.target.value;
    setSelectedDate(newDate); // Update state with the new selected date
    getDashBoard(id, newDate); // Fetch data based on the selected date
};

const getDashBoard = async (surveyId, cutoffDate) => {
  console.log(cutoffDate)
    try {
        setLoader(true);

        // Prepare the API request payload
        const data = { surveyId: surveyId.id };

        // Make the API call
        const surveyData = await api.post(`${Config.new.site_api}/client-survey/Dashboard`, data);
        console.log('API Response:', surveyData);

        // Validate the API response
        if (surveyData?.code === 200 && Array.isArray(surveyData.data)) {
            const cutoffDateObj = new Date(cutoffDate); // Convert selected date to Date object

            // Filter objects based on the date
            const filteredData = surveyData.data.filter((item) => {
                if (item?.date) {
                    const itemDate = new Date(item.date);
                    if (!isNaN(itemDate)) {
                        return itemDate > cutoffDateObj;
                    } else {
                        console.warn(`Invalid date format for item:`, item);
                        return false;
                    }
                } else {
                    console.warn(`Missing date field in item:`, item);
                    return false;
                }
            });

            setDashboardData(filteredData); // Update state with filtered data
        } else {
            console.error('Unexpected response structure or error in API:', surveyData);
        }
    } catch (error) {
        console.error('Error in getDashBoard:', error);
    } finally {
        setLoader(false);
    }
};

  const getSurveyById = async (id) => {
    let data = { id: id.id };
    let result = await api.post(`${Config.new.site_api}/client-survey/getSurvey`, data);

    console.log("survey Questions",result.data)
    if (result && result.code === 200) {
      const questionsWithState = result.data.questions.map(q => ({ ...q, isOpen: false }));
      setAllQuestions(questionsWithState);
    }
  };


  // Helper function to check if the question is in the checkarray
  const isQuestionInCheckArray = (question) => {
    
    return checkarray.includes(question);
  };
  const handleDownloadRupay = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    worksheet.getColumn(1).width = 45;
    worksheet.getColumn(2).width = 45;
    worksheet.getColumn(3).width = 23;
    worksheet.getColumn(4).width = 13;
    worksheet.getColumn(5).width = 13;
    worksheet.getColumn(6).width = 13
    worksheet.getColumn(7).width = 13;
    worksheet.getColumn(8).width = 13;
    worksheet.getColumn(9).width = 13;
    worksheet.getColumn(10).width = 13;
    worksheet.getColumn(11).width = 13;
    worksheet.getColumn(12).width = 13;
    worksheet.getColumn(13).width = 13;
    worksheet.getColumn(14).width = 13;
    worksheet.getColumn(15).width = 13;
    worksheet.getColumn(16).width = 13;
    worksheet.getColumn(17).width = 13;
    worksheet.getColumn(18).width = 13;
    worksheet.getColumn(19).width = 13;
    worksheet.getColumn(20).width = 13;
    worksheet.getColumn(21).width = 13;
    worksheet.getColumn(22).width = 13;
    worksheet.getColumn(23).width = 13;


    // Merger A Cells 
    worksheet.mergeCells('A3:A3');
    worksheet.mergeCells('A4:A11');
    worksheet.mergeCells('A12:A12');
    worksheet.mergeCells('A13:A14');
    worksheet.mergeCells('A15:A15');
    worksheet.mergeCells('A16:A18');
    worksheet.mergeCells('A19:A19');
    worksheet.mergeCells('A20:A21');
    worksheet.mergeCells('A22:A22');
    worksheet.mergeCells('A23:A24');
    worksheet.mergeCells('A25:A25');
    worksheet.mergeCells('A26:A26');
    worksheet.mergeCells('A27:A27');
    worksheet.mergeCells('A28:A30');
    worksheet.mergeCells('A31:A31');
    worksheet.mergeCells('A32:A33');
    worksheet.mergeCells('A34:A34');
    worksheet.mergeCells('A35:A35');
    worksheet.mergeCells('A36:A36');
    worksheet.mergeCells('A37:A39');
    worksheet.mergeCells('A40:A40');
    worksheet.mergeCells('A41:A43');
    worksheet.mergeCells('A44:A46');
    worksheet.mergeCells('A47:A49');
    worksheet.mergeCells('A50:A50');
    // Merge cells for headers
    worksheet.mergeCells('B3:B3');
    worksheet.mergeCells('B4:B4');
    worksheet.mergeCells('B5:B5');
    worksheet.mergeCells('B6:B6');
    worksheet.mergeCells('B7:B7');
    worksheet.mergeCells('B8:B8');
    worksheet.mergeCells('B9:B9');
    worksheet.mergeCells('B10:B10');
    worksheet.mergeCells('B11:B11');
    worksheet.mergeCells('B12:B12');
    worksheet.mergeCells('B13:B13');
    worksheet.mergeCells('B14:B14');
    worksheet.mergeCells('B15:B15');
    worksheet.mergeCells('B16:B16');
    worksheet.mergeCells('B17:B17');
    worksheet.mergeCells('B18:B18');
    worksheet.mergeCells('B19:B19');
    worksheet.mergeCells('B20:B20');
    worksheet.mergeCells('B21:B21');
    worksheet.mergeCells('B22:B22');
    worksheet.mergeCells('B23:B23');
    worksheet.mergeCells('B24:B24');
    worksheet.mergeCells('B25:B25');
    worksheet.mergeCells('B26:B26');
    worksheet.mergeCells('B27:B27');
    worksheet.mergeCells('B28:B28');
    worksheet.mergeCells('B29:B29');
    worksheet.mergeCells('B30:B30');
    worksheet.mergeCells('B31:B31');
    worksheet.mergeCells('B32:B32');
    worksheet.mergeCells('B33:B33');
    worksheet.mergeCells('B37:B39');
    worksheet.mergeCells('B44:B46');
    worksheet.mergeCells('B47:B49');
    worksheet.mergeCells('B50:B50');
   
    
   
    worksheet.mergeCells('C3:C3');
    worksheet.mergeCells('C4:C11');
    worksheet.mergeCells('C12:C12');
    worksheet.mergeCells('C13:C14');
     worksheet.mergeCells('C15:C15');
    worksheet.mergeCells('C16:C18');
    worksheet.mergeCells('C19:C19');
    worksheet.mergeCells('C20:C21');
    worksheet.mergeCells('C22:C22');
    worksheet.mergeCells('C23:C24');
    worksheet.mergeCells('C25:C25');
    worksheet.mergeCells('C26:C26');
    worksheet.mergeCells('C27:C27');
    worksheet.mergeCells('C28:C30');
     worksheet.mergeCells('C31:C31');
    worksheet.mergeCells('C32:C33');
    worksheet.mergeCells('C34:C34');
     worksheet.mergeCells('C35:C35');
     worksheet.mergeCells('C36:C36');
    worksheet.mergeCells('C37:C39');
    worksheet.mergeCells('C40:C40');
    worksheet.mergeCells('C41:C43');
    worksheet.mergeCells('C44:C46');
    worksheet.mergeCells('C47:C49');
    worksheet.mergeCells('C50:C50');
    

   
    // Merge cells for new headers
    worksheet.mergeCells('D1:CC1');
    worksheet.mergeCells('D2:F2');
    worksheet.mergeCells('G2:I2');
    worksheet.mergeCells('J2:L2');
    worksheet.mergeCells('M2:O2');
    worksheet.mergeCells('P2:R2');
    worksheet.mergeCells('S2:U2');
    worksheet.mergeCells('V2:X2');
    worksheet.mergeCells('Y2:AA2');
    worksheet.mergeCells('AB2:AD2');
    worksheet.mergeCells('AE2:AG2');
    worksheet.mergeCells('AH2:AJ2');
    worksheet.mergeCells('AK2:AM2');
    worksheet.mergeCells('AN2:AP2');
    worksheet.mergeCells('AQ2:AS2');
    worksheet.mergeCells('AT2:AV2');
    worksheet.mergeCells('AW2:AY2');
    worksheet.mergeCells('AZ2:BB2');
    worksheet.mergeCells('BC2:BE2');
    worksheet.mergeCells('BF2:BH2');
    worksheet.mergeCells('BI2:BK2');
    worksheet.mergeCells('BL2:BN2');
    worksheet.mergeCells('BO2:BQ2');
    worksheet.mergeCells('BR2:BT2');
    worksheet.mergeCells('BU2:BW2');
    worksheet.mergeCells('BX2:BZ2');
    worksheet.mergeCells('CA2:CC2');

    
     worksheet.mergeCells('D23:D24');
     worksheet.mergeCells('E23:E24');
     worksheet.mergeCells('F23:F24');
     worksheet.mergeCells('G23:G24');
     worksheet.mergeCells('H23:H24');
      worksheet.mergeCells('I23:I24');
     worksheet.mergeCells('J23:J24');
     worksheet.mergeCells('K23:K24');
      worksheet.mergeCells('L23:L24');
     worksheet.mergeCells('M23:M24');
     worksheet.mergeCells('N23:N24');
      worksheet.mergeCells('O23:O24');
     worksheet.mergeCells('P23:P24');
     worksheet.mergeCells('Q23:Q24');
      worksheet.mergeCells('R23:R24');
     worksheet.mergeCells('S23:S24');
     worksheet.mergeCells('T23:T24');
      worksheet.mergeCells('U23:U24');
     worksheet.mergeCells('V23:V24');
     worksheet.mergeCells('W23:W24');
      worksheet.mergeCells('X23:X24');
     worksheet.mergeCells('Y23:Y24');
     worksheet.mergeCells('Z23:Z24');
      worksheet.mergeCells('AA23:AA24');
     worksheet.mergeCells('AB23:AB24');
     worksheet.mergeCells('AC23:AC24');
      worksheet.mergeCells('AD23:AD24');
     worksheet.mergeCells('AE23:AE24');
     worksheet.mergeCells('AF23:AF24');
      worksheet.mergeCells('AG23:AG24');
     worksheet.mergeCells('AH23:AH24');
     worksheet.mergeCells('AI23:AI24');
      worksheet.mergeCells('AJ23:AJ24');
     worksheet.mergeCells('AK23:AK24');
     worksheet.mergeCells('AL23:AL24');
      worksheet.mergeCells('AM23:AM24');
     worksheet.mergeCells('AN23:AN24');
     worksheet.mergeCells('AO23:AO24');
      worksheet.mergeCells('AP23:AP24');
     worksheet.mergeCells('AQ23:AQ24');
     worksheet.mergeCells('AR23:AR24');
      worksheet.mergeCells('AS23:AS24');
     worksheet.mergeCells('AT23:AT24');
     worksheet.mergeCells('AU23:AU24');
      worksheet.mergeCells('AV23:AV24');
     worksheet.mergeCells('AW23:AW24');
     worksheet.mergeCells('AX23:AX24');
      worksheet.mergeCells('AY23:AY24');
     worksheet.mergeCells('AZ23:AZ24');
     worksheet.mergeCells('BA23:BA24');
     worksheet.mergeCells('BB23:BB24');
     worksheet.mergeCells('BC23:BC24');
      worksheet.mergeCells('BD23:BD24');
     worksheet.mergeCells('BE23:BE24');
     worksheet.mergeCells('BF23:BF24');
      worksheet.mergeCells('BG23:BG24');
     worksheet.mergeCells('BH23:BH24');
     worksheet.mergeCells('BI23:BI24');
      worksheet.mergeCells('BJ23:BJ24');
     worksheet.mergeCells('BK23:BK24');
     worksheet.mergeCells('BL23:BL24');
      worksheet.mergeCells('BM23:BM24');
     worksheet.mergeCells('BN23:BN24');
     worksheet.mergeCells('BO23:BO24');
      worksheet.mergeCells('BP23:BP24');
     worksheet.mergeCells('BQ23:BQ24');
     worksheet.mergeCells('BR23:BR24');
      worksheet.mergeCells('BS23:BS24');
     worksheet.mergeCells('BT23:BT24');
     worksheet.mergeCells('BU23:BU24');
      worksheet.mergeCells('BV23:BV24');
     worksheet.mergeCells('BW23:BW24');
     worksheet.mergeCells('BX23:BX24');
      worksheet.mergeCells('BY23:BY24');
     worksheet.mergeCells('BZ23:BZ24');
      worksheet.mergeCells('CA23:CA24');
     worksheet.mergeCells('CB23:CB24');
      worksheet.mergeCells('CC23:CC24');


    
     worksheet.mergeCells('D32:D33');
     worksheet.mergeCells('E32:E33');
     worksheet.mergeCells('F32:F33');
     worksheet.mergeCells('G32:G33');
     worksheet.mergeCells('H32:H33');
      worksheet.mergeCells('I32:I33');
     worksheet.mergeCells('J32:J33');
     worksheet.mergeCells('K32:K33');
      worksheet.mergeCells('L32:L33');
     worksheet.mergeCells('M32:M33');
     worksheet.mergeCells('N32:N33');
      worksheet.mergeCells('O32:O33');
     worksheet.mergeCells('P32:P33');
     worksheet.mergeCells('Q32:Q33');
      worksheet.mergeCells('R32:R33');
     worksheet.mergeCells('S32:S33');
     worksheet.mergeCells('T32:T33');
      worksheet.mergeCells('U32:U33');
     worksheet.mergeCells('V32:V33');
     worksheet.mergeCells('W32:W33');
      worksheet.mergeCells('X32:X33');
     worksheet.mergeCells('Y32:Y33');
     worksheet.mergeCells('Z32:Z33');
      worksheet.mergeCells('AA32:AA33');
     worksheet.mergeCells('AB32:AB33');
     worksheet.mergeCells('AC32:AC33');
      worksheet.mergeCells('AD32:AD33');
     worksheet.mergeCells('AE32:AE33');
     worksheet.mergeCells('AF32:AF33');
      worksheet.mergeCells('AG32:AG33');
     worksheet.mergeCells('AH32:AH33');
     worksheet.mergeCells('AI32:AI33');
      worksheet.mergeCells('AJ32:AJ33');
     worksheet.mergeCells('AK32:AK33');
     worksheet.mergeCells('AL32:AL33');
      worksheet.mergeCells('AM32:AM33');
     worksheet.mergeCells('AN32:AN33');
     worksheet.mergeCells('AO32:AO33');
      worksheet.mergeCells('AP32:AP33');
     worksheet.mergeCells('AQ32:AQ33');
     worksheet.mergeCells('AR32:AR33');
      worksheet.mergeCells('AS32:AS33');
     worksheet.mergeCells('AT32:AT33');
     worksheet.mergeCells('AU32:AU33');
      worksheet.mergeCells('AV32:AV33');
     worksheet.mergeCells('AW32:AW33');
     worksheet.mergeCells('AX32:AX33');
      worksheet.mergeCells('AY32:AY33');
     worksheet.mergeCells('AZ32:AZ33');
     worksheet.mergeCells('BA32:BA33');
     worksheet.mergeCells('BB32:BB33');
     worksheet.mergeCells('BC32:BC33');
      worksheet.mergeCells('BD32:BD33');
     worksheet.mergeCells('BE32:BE33');
     worksheet.mergeCells('BF32:BF33');
      worksheet.mergeCells('BG32:BG33');
     worksheet.mergeCells('BH32:BH33');
     worksheet.mergeCells('BI32:BI33');
      worksheet.mergeCells('BJ32:BJ33');
     worksheet.mergeCells('BK32:BK33');
     worksheet.mergeCells('BL32:BL33');
      worksheet.mergeCells('BM32:BM33');
     worksheet.mergeCells('BN32:BN33');
     worksheet.mergeCells('BO32:BO33');
      worksheet.mergeCells('BP32:BP33');
     worksheet.mergeCells('BQ32:BQ33');
     worksheet.mergeCells('BR32:BR33');
      worksheet.mergeCells('BS32:BS33');
     worksheet.mergeCells('BT32:BT33');
     worksheet.mergeCells('BU32:BU33');
      worksheet.mergeCells('BV32:BV33');
     worksheet.mergeCells('BW32:BW33');
     worksheet.mergeCells('BX32:BX33');
      worksheet.mergeCells('BY32:BY33');
     worksheet.mergeCells('BZ32:BZ33');
      worksheet.mergeCells('CA32:CA33');
     worksheet.mergeCells('CB32:CB33');
      worksheet.mergeCells('CC32:CC33');
     
    worksheet.mergeCells('D37:D39');
     worksheet.mergeCells('E37:E39');
     worksheet.mergeCells('F37:F39');
     worksheet.mergeCells('G37:G39');
     worksheet.mergeCells('H37:H39');
      worksheet.mergeCells('I37:I39');
     worksheet.mergeCells('J37:J39');
     worksheet.mergeCells('K37:K39');
      worksheet.mergeCells('L37:L39');
     worksheet.mergeCells('M37:M39');
     worksheet.mergeCells('N37:N39');
      worksheet.mergeCells('O37:O39');
     worksheet.mergeCells('P37:P39');
     worksheet.mergeCells('Q37:Q39');
      worksheet.mergeCells('R37:R39');
     worksheet.mergeCells('S37:S39');
     worksheet.mergeCells('T37:T39');
      worksheet.mergeCells('U37:U39');
     worksheet.mergeCells('V37:V39');
     worksheet.mergeCells('W37:W39');
      worksheet.mergeCells('X37:X39');
     worksheet.mergeCells('Y37:Y39');
     worksheet.mergeCells('Z37:Z39');
      worksheet.mergeCells('AA37:AA39');
     worksheet.mergeCells('AB37:AB39');
     worksheet.mergeCells('AC37:AC39');
      worksheet.mergeCells('AD37:AD39');
     worksheet.mergeCells('AE37:AE39');
     worksheet.mergeCells('AF37:AF39');
      worksheet.mergeCells('AG37:AG39');
     worksheet.mergeCells('AH37:AH39');
     worksheet.mergeCells('AI37:AI39');
      worksheet.mergeCells('AJ37:AJ39');
     worksheet.mergeCells('AK37:AK39');
     worksheet.mergeCells('AL37:AL39');
      worksheet.mergeCells('AM37:AM39');
     worksheet.mergeCells('AN37:AN39');
     worksheet.mergeCells('AO37:AO39');
      worksheet.mergeCells('AP37:AP39');
     worksheet.mergeCells('AQ37:AQ39');
     worksheet.mergeCells('AR37:AR39');
      worksheet.mergeCells('AS37:AS39');
     worksheet.mergeCells('AT37:AT39');
     worksheet.mergeCells('AU37:AU39');
      worksheet.mergeCells('AV37:AV39');
     worksheet.mergeCells('AW37:AW39');
     worksheet.mergeCells('AX37:AX39');
      worksheet.mergeCells('AY37:AY39');
     worksheet.mergeCells('AZ37:AZ39');
     worksheet.mergeCells('BA37:BA39');
     worksheet.mergeCells('BB37:BB39');
     worksheet.mergeCells('BC37:BC39');
      worksheet.mergeCells('BD37:BD39');
     worksheet.mergeCells('BE37:BE39');
     worksheet.mergeCells('BF37:BF39');
      worksheet.mergeCells('BG37:BG39');
     worksheet.mergeCells('BH37:BH39');
     worksheet.mergeCells('BI37:BI39');
      worksheet.mergeCells('BJ37:BJ39');
     worksheet.mergeCells('BK37:BK39');
     worksheet.mergeCells('BL37:BL39');
      worksheet.mergeCells('BM37:BM39');
     worksheet.mergeCells('BN37:BN39');
     worksheet.mergeCells('BO37:BO39');
      worksheet.mergeCells('BP37:BP39');
     worksheet.mergeCells('BQ37:BQ39');
     worksheet.mergeCells('BR37:BR39');
      worksheet.mergeCells('BS37:BS39');
     worksheet.mergeCells('BT37:BT39');
     worksheet.mergeCells('BU37:BU39');
      worksheet.mergeCells('BV37:BV39');
     worksheet.mergeCells('BW37:BW39');
     worksheet.mergeCells('BX37:BX39');
      worksheet.mergeCells('BY37:BY39');
     worksheet.mergeCells('BZ37:BZ39');
      worksheet.mergeCells('CA37:CA39');
     worksheet.mergeCells('CB37:CB39');
      worksheet.mergeCells('CC37:CC39');
     

     worksheet.mergeCells('D41:D43');
     worksheet.mergeCells('E41:E43');
     worksheet.mergeCells('F41:F43');
     worksheet.mergeCells('G41:G43');
     worksheet.mergeCells('H41:H43');
      worksheet.mergeCells('I41:I43');
     worksheet.mergeCells('J41:J43');
     worksheet.mergeCells('K41:K43');
      worksheet.mergeCells('L41:L43');
     worksheet.mergeCells('M41:M43');
     worksheet.mergeCells('N41:N43');
      worksheet.mergeCells('O41:O43');
     worksheet.mergeCells('P41:P43');
     worksheet.mergeCells('Q41:Q43');
      worksheet.mergeCells('R41:R43');
     worksheet.mergeCells('S41:S43');
     worksheet.mergeCells('T41:T43');
      worksheet.mergeCells('U41:U43');
     worksheet.mergeCells('V41:V43');
     worksheet.mergeCells('W41:W43');
      worksheet.mergeCells('X41:X43');
     worksheet.mergeCells('Y41:Y43');
     worksheet.mergeCells('Z41:Z43');
      worksheet.mergeCells('AA41:AA43');
     worksheet.mergeCells('AB41:AB43');
     worksheet.mergeCells('AC41:AC43');
      worksheet.mergeCells('AD41:AD43');
     worksheet.mergeCells('AE41:AE43');
     worksheet.mergeCells('AF41:AF43');
      worksheet.mergeCells('AG41:AG43');
     worksheet.mergeCells('AH41:AH43');
     worksheet.mergeCells('AI41:AI43');
      worksheet.mergeCells('AJ41:AJ43');
     worksheet.mergeCells('AK41:AK43');
     worksheet.mergeCells('AL41:AL43');
      worksheet.mergeCells('AM41:AM43');
     worksheet.mergeCells('AN41:AN43');
     worksheet.mergeCells('AO41:AO43');
      worksheet.mergeCells('AP41:AP43');
     worksheet.mergeCells('AQ41:AQ43');
     worksheet.mergeCells('AR41:AR43');
      worksheet.mergeCells('AS41:AS43');
     worksheet.mergeCells('AT41:AT43');
     worksheet.mergeCells('AU41:AU43');
      worksheet.mergeCells('AV41:AV43');
     worksheet.mergeCells('AW41:AW43');
     worksheet.mergeCells('AX41:AX43');
      worksheet.mergeCells('AY41:AY43');
     worksheet.mergeCells('AZ41:AZ43');
     worksheet.mergeCells('BA41:BA43');
     worksheet.mergeCells('BB41:BB43');
     worksheet.mergeCells('BC41:BC43');
      worksheet.mergeCells('BD41:BD43');
     worksheet.mergeCells('BE41:BE43');
     worksheet.mergeCells('BF41:BF43');
      worksheet.mergeCells('BG41:BG43');
     worksheet.mergeCells('BH41:BH43');
     worksheet.mergeCells('BI41:BI43');
      worksheet.mergeCells('BJ41:BJ43');
     worksheet.mergeCells('BK41:BK43');
     worksheet.mergeCells('BL41:BL43');
      worksheet.mergeCells('BM41:BM43');
     worksheet.mergeCells('BN41:BN43');
     worksheet.mergeCells('BO41:BO43');
      worksheet.mergeCells('BP41:BP43');
     worksheet.mergeCells('BQ41:BQ43');
     worksheet.mergeCells('BR41:BR43');
      worksheet.mergeCells('BS41:BS43');
     worksheet.mergeCells('BT41:BT43');
     worksheet.mergeCells('BU41:BU43');
      worksheet.mergeCells('BV41:BV43');
     worksheet.mergeCells('BW41:BW43');
     worksheet.mergeCells('BX41:BX43');
      worksheet.mergeCells('BY41:BY43');
     worksheet.mergeCells('BZ41:BZ43');
      worksheet.mergeCells('CA41:CA43');
     worksheet.mergeCells('CB41:CB43');
      worksheet.mergeCells('CC41:CC43');


      
     worksheet.mergeCells('D44:D46');
     worksheet.mergeCells('E44:E46');
     worksheet.mergeCells('F44:F46');
     worksheet.mergeCells('G44:G46');
     worksheet.mergeCells('H44:H46');
      worksheet.mergeCells('I44:I46');
     worksheet.mergeCells('J44:J46');
     worksheet.mergeCells('K44:K46');
      worksheet.mergeCells('L44:L46');
     worksheet.mergeCells('M44:M46');
     worksheet.mergeCells('N44:N46');
      worksheet.mergeCells('O44:O46');
     worksheet.mergeCells('P44:P46');
     worksheet.mergeCells('Q44:Q46');
      worksheet.mergeCells('R44:R46');
     worksheet.mergeCells('S44:S46');
     worksheet.mergeCells('T44:T46');
      worksheet.mergeCells('U44:U46');
     worksheet.mergeCells('V44:V46');
     worksheet.mergeCells('W44:W46');
      worksheet.mergeCells('X44:X46');
     worksheet.mergeCells('Y44:Y46');
     worksheet.mergeCells('Z44:Z46');
      worksheet.mergeCells('AA44:AA46');
     worksheet.mergeCells('AB44:AB46');
     worksheet.mergeCells('AC44:AC46');
      worksheet.mergeCells('AD44:AD46');
     worksheet.mergeCells('AE44:AE46');
     worksheet.mergeCells('AF44:AF46');
      worksheet.mergeCells('AG44:AG46');
     worksheet.mergeCells('AH44:AH46');
     worksheet.mergeCells('AI44:AI46');
      worksheet.mergeCells('AJ44:AJ46');
     worksheet.mergeCells('AK44:AK46');
     worksheet.mergeCells('AL44:AL46');
      worksheet.mergeCells('AM44:AM46');
     worksheet.mergeCells('AN44:AN46');
     worksheet.mergeCells('AO44:AO46');
      worksheet.mergeCells('AP44:AP46');
     worksheet.mergeCells('AQ44:AQ46');
     worksheet.mergeCells('AR44:AR46');
      worksheet.mergeCells('AS44:AS46');
     worksheet.mergeCells('AT44:AT46');
     worksheet.mergeCells('AU44:AU46');
      worksheet.mergeCells('AV44:AV46');
     worksheet.mergeCells('AW44:AW46');
     worksheet.mergeCells('AX44:AX46');
      worksheet.mergeCells('AY44:AY46');
     worksheet.mergeCells('AZ44:AZ46');
     worksheet.mergeCells('BA44:BA46');
     worksheet.mergeCells('BB44:BB46');
     worksheet.mergeCells('BC44:BC46');
      worksheet.mergeCells('BD44:BD46');
     worksheet.mergeCells('BE44:BE46');
     worksheet.mergeCells('BF44:BF46');
      worksheet.mergeCells('BG44:BG46');
     worksheet.mergeCells('BH44:BH46');
     worksheet.mergeCells('BI44:BI46');
      worksheet.mergeCells('BJ44:BJ46');
     worksheet.mergeCells('BK44:BK46');
     worksheet.mergeCells('BL44:BL46');
      worksheet.mergeCells('BM44:BM46');
     worksheet.mergeCells('BN44:BN46');
     worksheet.mergeCells('BO44:BO46');
      worksheet.mergeCells('BP44:BP46');
     worksheet.mergeCells('BQ44:BQ46');
     worksheet.mergeCells('BR44:BR46');
      worksheet.mergeCells('BS44:BS46');
     worksheet.mergeCells('BT44:BT46');
     worksheet.mergeCells('BU44:BU46');
      worksheet.mergeCells('BV44:BV46');
     worksheet.mergeCells('BW44:BW46');
     worksheet.mergeCells('BX44:BX46');
      worksheet.mergeCells('BY44:BY46');
     worksheet.mergeCells('BZ44:BZ46');
      worksheet.mergeCells('CA44:CA46');
     worksheet.mergeCells('CB44:CB46');
     worksheet.mergeCells('CC44:CC46');

     
     worksheet.mergeCells('D47:D49');
     worksheet.mergeCells('E47:E49');
     worksheet.mergeCells('F47:F49');
     worksheet.mergeCells('G47:G49');
     worksheet.mergeCells('H47:H49');
      worksheet.mergeCells('I47:I49');
     worksheet.mergeCells('J47:J49');
     worksheet.mergeCells('K47:K49');
      worksheet.mergeCells('L47:L49');
     worksheet.mergeCells('M47:M49');
     worksheet.mergeCells('N47:N49');
      worksheet.mergeCells('O47:O49');
     worksheet.mergeCells('P47:P49');
     worksheet.mergeCells('Q47:Q49');
      worksheet.mergeCells('R47:R49');
     worksheet.mergeCells('S47:S49');
     worksheet.mergeCells('T47:T49');
      worksheet.mergeCells('U47:U49');
     worksheet.mergeCells('V47:V49');
     worksheet.mergeCells('W47:W49');
      worksheet.mergeCells('X47:X49');
     worksheet.mergeCells('Y47:Y49');
     worksheet.mergeCells('Z47:Z49');
      worksheet.mergeCells('AA47:AA49');
     worksheet.mergeCells('AB47:AB49');
     worksheet.mergeCells('AC47:AC49');
      worksheet.mergeCells('AD47:AD49');
     worksheet.mergeCells('AE47:AE49');
     worksheet.mergeCells('AF47:AF49');
      worksheet.mergeCells('AG47:AG49');
     worksheet.mergeCells('AH47:AH49');
     worksheet.mergeCells('AI47:AI49');
      worksheet.mergeCells('AJ47:AJ49');
     worksheet.mergeCells('AK47:AK49');
     worksheet.mergeCells('AL47:AL49');
      worksheet.mergeCells('AM47:AM49');
     worksheet.mergeCells('AN47:AN49');
     worksheet.mergeCells('AO47:AO49');
      worksheet.mergeCells('AP47:AP49');
     worksheet.mergeCells('AQ47:AQ49');
     worksheet.mergeCells('AR47:AR49');
      worksheet.mergeCells('AS47:AS49');
     worksheet.mergeCells('AT47:AT49');
     worksheet.mergeCells('AU47:AU49');
      worksheet.mergeCells('AV47:AV49');
     worksheet.mergeCells('AW47:AW49');
     worksheet.mergeCells('AX47:AX49');
      worksheet.mergeCells('AY47:AY49');
     worksheet.mergeCells('AZ47:AZ49');
     worksheet.mergeCells('BA47:BA49');
     worksheet.mergeCells('BB47:BB49');
     worksheet.mergeCells('BC47:BC49');
      worksheet.mergeCells('BD47:BD49');
     worksheet.mergeCells('BE47:BE49');
     worksheet.mergeCells('BF47:BF49');
      worksheet.mergeCells('BG47:BG49');
     worksheet.mergeCells('BH47:BH49');
     worksheet.mergeCells('BI47:BI49');
      worksheet.mergeCells('BJ47:BJ49');
     worksheet.mergeCells('BK47:BK49');
     worksheet.mergeCells('BL47:BL49');
      worksheet.mergeCells('BM47:BM49');
     worksheet.mergeCells('BN47:BN49');
     worksheet.mergeCells('BO47:BO49');
      worksheet.mergeCells('BP47:BP49');
     worksheet.mergeCells('BQ47:BQ49');
     worksheet.mergeCells('BR47:BR49');
      worksheet.mergeCells('BS47:BS49');
     worksheet.mergeCells('BT47:BT49');
     worksheet.mergeCells('BU47:BU49');
      worksheet.mergeCells('BV47:BV49');
     worksheet.mergeCells('BW47:BW49');
     worksheet.mergeCells('BX47:BX49');
      worksheet.mergeCells('BY47:BY49');
     worksheet.mergeCells('BZ47:BZ49');
      worksheet.mergeCells('CA47:CA49');
     worksheet.mergeCells('CB47:CB49');
      worksheet.mergeCells('CC47:CC49');


   

    // Define styles
    const headerStyle = {
      font: { bold: true, color: { argb: '00000000' } },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'fffed9' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      }
    };

    const plannedstyle = {
      font: { bold: false, color: { argb: '00000000' } },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'bdd3f9' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      }
    };
    const cellStyle = {
      font: { bold: false, color: { argb: '00000000' } },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      }
    };
    const SpecialStyle = {
      font: { bold: false, color: { argb: '00000000' } },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e3e3e3' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      }
    };
    const plannedcellstyle = {
      font: { bold: false, color: { argb: '00000000' } },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      }
    };
    const achievedstyle = {
      font: { color: { argb: '00000000' }, size: 12, },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '92c67c' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      }
    };
    const achievedcellstyle = {
      font: { bold: false, color: { argb: '00000000' } },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      }
    };
    const pendingtyle = {
      font: { color: { argb: '00000000' } },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffcc98' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      }
    };
    const pendingcellstyle = {
      font: { bold: false, color: { argb: '00000000' } },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      }
    };


      const cellsToStyleA= [
      { cell: 'A3', value: 'Main Categories' },
      { cell: 'A4', value: 'Groceries /supermarkets' },
      { cell: 'A12', value: 'Total' },
      { cell: 'A13', value: 'Cigar Shop' },
      { cell: 'A15', value: 'Total' },
      { cell: 'A16', value: 'Fast food and restaurants' },
      { cell: 'A19', value: 'Total' },
      { cell: 'A20', value: 'Service stations' },
      { cell: 'A22', value: 'Total' },
      { cell: 'A23', value: 'Telecommunication services' },
      { cell: 'A25', value: 'Total' },
      { cell: 'A26', value: 'Dairies' },
      { cell: 'A27', value: 'Total' },
      { cell: 'A28', value: 'Men’s and women’s clothing shops' },
      { cell: 'A31', value: 'Total' },
      { cell: 'A32', value: 'Drug stores and pharmacies' },
      { cell: 'A34', value: 'Total' },
      { cell: 'A35', value: 'Beauty and barber shops' },
      { cell: 'A36', value: 'Total' },
      { cell: 'A37', value: 'Taxi-cabs and limousines' },
      { cell: 'A40', value: 'Total' },
      { cell: 'A41', value: 'Electronic &appliance store/Repair Shops' },
      { cell: 'A44', value: 'Package liquor shops (beer, wine, liquor)' },
      { cell: 'A47', value: 'Premium category' },
      { cell: 'A50', value: 'Over All Total' },
                                
     
      
    ];

    cellsToStyleA.forEach(({ cell, value }) => {


      const excelCell = worksheet.getCell(cell);
      excelCell.value = value;
      if (value == "Main Categories" || value == "Total" || value == "Over All Total") {
        excelCell.font = headerStyle.font;
        excelCell.fill = headerStyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      }
     
    });

    const cellsToStyleB= [
      { cell: 'B3', value: 'Fall under Main Category' },
      { cell: 'B4', value: 'Kirana/Grocery store' },
      { cell: 'B5', value: 'Fruit / Vegetable Vendors' },
      { cell: 'B6', value: 'Stationery / General Stores' },
      { cell: 'B7', value: 'Meat / Fish Shops' },
      { cell: 'B8', value: 'Sweet Shops/Mithai Shop' },
      { cell: 'B9', value: 'Ice Cream / Dessert Parlors' },
      { cell: 'B10', value: 'Departmantel store/Supermarkets/Walmart/Dmart' },
      { cell: 'B11', value: 'Bakery' },
      { cell: 'B12', value: 'Total' },
      { cell: 'B13', value: 'Tea/Coffe stall' },
      { cell: 'B14', value: 'Pan/Cigarette/Bedi Shop' },
      { cell: 'B15', value: 'Total' },
      { cell: 'B16', value: 'Street food vendors' },
      { cell: 'B17', value: 'Restaurants / Dhabas/Café/Chains' },
      { cell: 'B18', value: 'Juice / Coconut Water Vendors' },
      { cell: 'B19', value: 'Total' },
      { cell: 'B20', value: 'LPG/CNG/Gas/Fuel (Diesel/Petrol) Stations' },
      { cell: 'B21', value: 'Car / Bike Workshops/Repair Shop' },
      { cell: 'B22', value: 'Total' },
      { cell: 'B23', value: 'Smartphone Retail shop /VI/Airtel/jio' },
      { cell: 'B24', value: 'Cyber Cafes / Photocopy Shops' },
      { cell: 'B25', value: 'Total' },
      { cell: 'B26', value: 'Dairy' },
      { cell: 'B27', value: 'Total' },
      { cell: 'B28', value: 'Branded Clothing Store' },
      { cell: 'B29', value: 'Men’s and women’s clothing shops' },
      { cell: 'B30', value: 'Tailor shop' },
      { cell: 'B31', value: 'Total' },
      { cell: 'B32', value: 'Chemists / Medical Stores/Pathology Labs' },
      { cell: 'B33', value: 'Hospitals/Clinics / Doctors' },
      { cell: 'B34', value: 'Total' },
      { cell: 'B35', value: 'Salons / Beauty Parlours/ Beauty and barber shops' },
      { cell: 'B36', value: 'Total' },
      { cell: 'B37', value: 'Auto Rickshaws/Bike Taxis/Cab Operators/ Porter / Uber / Ola / Rapido / Travel / Railway / Metro / Bus' },
      // { cell: 'B38', value: 'Porter/Uber/Ola/Rapido' },
      // { cell: 'B39', value: 'Travel/Railway/Metro/Bus' },
      { cell: 'B40', value: 'Total' },
      { cell: 'B41', value: 'Consumer Durables/Home Appliance Stores (TV, Mixer, etc.)' },
      { cell: 'B42', value: 'Electrical/ Plumbing/Hardware Stores' },
      { cell: 'B43', value: 'Electronics Repair Shops/ Mobile Repair/Accessory Shops' },
      { cell: 'B44', value: 'Beer, wine, liquor shop' },
      { cell: 'B47', value: 'Airport stores, Malls,' },
      { cell: 'B50', value: 'Over All Total' },
                                
     
      
    ];

    cellsToStyleB.forEach(({ cell, value }) => {


      const excelCell = worksheet.getCell(cell);
      excelCell.value = value;
      if (value == "Fall under Main Category" || value == "Total" || value == "Over All Total") {
        excelCell.font = headerStyle.font;
        excelCell.fill = headerStyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      }
     
    });

    // Define cell values and styles for column B
    const cellsToStyleC = [
      { cell: 'C3', value: 'Sample Size' },
      { cell: 'C4', value: '1056(40%)' },
      { cell: 'C12', value: 'Total' },
      { cell: 'C13', value: '660 (25%)' },
      { cell: 'C15', value: 'Total' },
      { cell: 'C16', value: '528 (20%)' },
      { cell: 'C19', value: 'Total' },
      { cell: 'C20', value: '264 (10%)' },
      { cell: 'C22', value: 'Total' },
      { cell: 'C23', value: '132 (5%)' },
      { cell: 'C25', value: 'Total' },
      { cell: 'C26', value: '440 (40%)' },
      { cell: 'C27', value: 'Total' },
      { cell: 'C28', value: '352 (32%)' },
      { cell: 'C31', value: 'Total' },
      { cell: 'C32', value: '198 (18%)' },
      { cell: 'C34', value: 'Total' },
      { cell: 'C35', value: '110 (10%)' },
      { cell: 'C36', value: 'Total' },
      { cell: 'C37', value: '330 (50%)' },
      { cell: 'C40', value: 'Total' },
      { cell: 'C41', value: '198 (30%)' },
      { cell: 'C44', value: '99 (15%)' },
      { cell: 'C47', value: '33 (5%)' },
      { cell: 'C50', value: '4400' },
      
    

    ];

    cellsToStyleC.forEach(({ cell, value }) => {


      const excelCell = worksheet.getCell(cell);
      excelCell.value = value;
      if (value == "Sample Size" || value == "Total") {
        excelCell.font = headerStyle.font;
        excelCell.fill = headerStyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      }
    });

     

    // Define cell values and styles for new headers
    const cellsToStyleNew = [
      { cell: 'D1', value: 'Quota Sheet' },
      { cell: 'D2', value: 'Total' },
      { cell: 'G2', value: 'Delhi' },
      { cell: 'J2', value: 'Jaipur' },
      { cell: 'M2', value: 'Lucknow' },
      { cell: 'P2', value: 'Kanpur' },
      { cell: 'S2', value: 'Bengaluru' },
      { cell: 'V2', value: 'Chennai' },
      { cell: 'Y2', value: 'Hyderabad' },
      { cell: 'AB2', value: 'Guwahati' },
      { cell: 'AE2', value: 'Kolkata' },
      { cell: 'AH2', value: 'Patna' },
      { cell: 'AK2', value: 'Ahmedabad' },
      { cell: 'AN2', value: 'Surat' },
      { cell: 'AQ2', value: 'Indore' },
      { cell: 'AT2', value: 'Mumbai' },
      { cell: 'AW2', value: 'Pune' },
      { cell: 'AZ2', value: 'Jabalpur' },
      { cell: 'BC2', value: 'Dharamsala' },
      { cell: 'BF2', value: 'Ludhiana' },
      { cell: 'BI2', value: 'Rohtak' },
      { cell: 'BL2', value: 'Cochin' },
      { cell: 'BO2', value: 'Mysuru' },
      { cell: 'BR2', value: 'Vijayawada' },
      { cell: 'BU2', value: 'Bhubaneswar' },
      { cell: 'BX2', value: 'Ranchi' },
      { cell: 'CA2', value: 'Panaji' },

      { cell: 'D3', value: 'Planned' },
      { cell: 'E3', value: 'Achieved' },
      { cell: 'F3', value: 'Pending' },
      { cell: 'G3', value: 'Planned' },
      { cell: 'H3', value: 'Achieved' },
      { cell: 'I3', value: 'Pending' },
      { cell: 'J3', value: 'Planned' },
      { cell: 'K3', value: 'Achieved' },
      { cell: 'L3', value: 'Pending' },
      { cell: 'M3', value: 'Planned' },
      { cell: 'N3', value: 'Achieved' },
      { cell: 'O3', value: 'Pending' },
      { cell: 'P3', value: 'Planned' },
      { cell: 'Q3', value: 'Achieved' },
      { cell: 'R3', value: 'Pending' },
      { cell: 'S3', value: 'Planned' },
      { cell: 'T3', value: 'Achieved' },
      { cell: 'U3', value: 'Pending' },
      { cell: 'V3', value: 'Planned' },
      { cell: 'W3', value: 'Achieved' },
      { cell: 'X3', value: 'Pending' },
      { cell: 'Y3', value: 'Planned' },
      { cell: 'Z3', value: 'Achieved' },
      { cell: 'AA3', value: 'Pending' },
      { cell: 'AB3', value: 'Planned' },
      { cell: 'AC3', value: 'Achieved' },
      { cell: 'AD3', value: 'Pending' },
      { cell: 'AE3', value: 'Planned' },
      { cell: 'AF3', value: 'Achieved' },
      { cell: 'AG3', value: 'Pending' },
      { cell: 'AH3', value: 'Planned' },
      { cell: 'AI3', value: 'Achieved' },
      { cell: 'AJ3', value: 'Pending' },
      { cell: 'AK3', value: 'Planned' },
      { cell: 'AL3', value: 'Achieved' },
      { cell: 'AM3', value: 'Pending' },
      { cell: 'AN3', value: 'Planned' },
      { cell: 'AO3', value: 'Achieved' },
      { cell: 'AP3', value: 'Pending' },
      { cell: 'AQ3', value: 'Planned' },
      { cell: 'AR3', value: 'Achieved' },
      { cell: 'AS3', value: 'Pending' },
      { cell: 'AT3', value: 'Planned' },
      { cell: 'AU3', value: 'Achieved' },
      { cell: 'AV3', value: 'Pending' },
      { cell: 'AW3', value: 'Planned' },
      { cell: 'AX3', value: 'Achieved' },
      { cell: 'AY3', value: 'Pending' },
      { cell: 'AZ3', value: 'Planned' },
      { cell: 'BA3', value: 'Achieved' },
      { cell: 'BB3', value: 'Pending' },
      { cell: 'BC3', value: 'Planned' },
      { cell: 'BD3', value: 'Achieved' },
      { cell: 'BE3', value: 'Pending' },
      { cell: 'BF3', value: 'Planned' },
      { cell: 'BG3', value: 'Achieved' },
      { cell: 'BH3', value: 'Pending' },
      { cell: 'BI3', value: 'Planned' },
      { cell: 'BJ3', value: 'Achieved' },
      { cell: 'BK3', value: 'Pending' },
      { cell: 'BL3', value: 'Planned' },
      { cell: 'BM3', value: 'Achieved' },
      { cell: 'BN3', value: 'Pending' },
      { cell: 'BO3', value: 'Planned' },
      { cell: 'BP3', value: 'Achieved' },
      { cell: 'BQ3', value: 'Pending' },
      { cell: 'BR3', value: 'Planned' },
      { cell: 'BS3', value: 'Achieved' },
      { cell: 'BT3', value: 'Pending' },
      { cell: 'BU3', value: 'Planned' },
      { cell: 'BV3', value: 'Achieved' },
      { cell: 'BW3', value: 'Pending' },
      { cell: 'BX3', value: 'Planned' },
      { cell: 'BY3', value: 'Achieved' },
      { cell: 'BZ3', value: 'Pending' },
      { cell: 'CA3', value: 'Planned' },
      { cell: 'CB3', value: 'Achieved' },
      { cell: 'CC3', value: 'Pending' },
      
      
    
    ];

    let data2 = ['Quota Sheet']
    cellsToStyleNew.forEach(({ cell, value }) => {
      const excelCell = worksheet.getCell(cell);
      excelCell.value = value;
      if (data2.includes(value)) {
        excelCell.font = headerStyle.font;
        excelCell.fill = SpecialStyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      } else if (value == 'Planned') {
        excelCell.font = headerStyle.font;
        excelCell.fill = plannedstyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      } else if (value == 'Achieved') {
        excelCell.font = headerStyle.font;
        excelCell.fill = achievedstyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      } else if (value == 'Pending') {
        excelCell.font = headerStyle.font;
        excelCell.fill = pendingtyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      }
      else {
        // excelCell.fill = headerStyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
        excelCell.fill = headerStyle.fill;
        excelCell.font = headerStyle.font;
      }

    });


        let columnCValues = []
   

   if (id?.id == "688716b052a839aadb5234ca") {
      columnCValues = [240,240,150,25,150,105,40,105,345,320,200,200,120,160,105,135,450,145,145,80,180 ,315,105,200,105,33,4400]
    }
 
   
    let valueIndexC = 0;
    for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
   
    if (rowIndex === 12 ||  rowIndex === 15 || rowIndex === 19 ||rowIndex === 22 || rowIndex === 25  || rowIndex === 24 || rowIndex === 27 ||rowIndex === 31 || rowIndex === 32 ||rowIndex === 34  || rowIndex === 36 ||rowIndex === 38  || rowIndex === 39 || rowIndex === 40 || rowIndex === 41 || rowIndex === 42 || rowIndex === 44 || rowIndex === 45 || rowIndex === 47 || rowIndex === 48) continue;

        const cellD = worksheet.getCell(`D${rowIndex}`);
        cellD.value = columnCValues[valueIndexC++];
        if (rowIndex == 49) {
          cellD.font = headerStyle.font
          cellD.fill = cellStyle.fill;
        } 
        else {
          cellD.font = cellStyle.font;
          cellD.fill = plannedcellstyle.fill;

        }

       
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      

    }


   

    
    let columnFValues = []
   

   if (id?.id == "688716b052a839aadb5234ca") {
      columnFValues = [12,12,8,1,8,5,2,5,17,16,10,10,6,8,5,7,22,7,7,4,10,16,6,10,5,33,220]
    }
 
    
    let valueIndex = 0;
    let datatowrite=['Total','1056(40%)','660 (25%)','528 (20%)','264 (10%)','132 (5%)','440 (40%)','352 (32%)','198 (18%)','110 (10%)','330 (50%)','198 (30%)','99 (15%)','33 (5%)']
   for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
  // Skip rows 20 and 26
 if (rowIndex === 12 ||  rowIndex === 15 || rowIndex === 19 ||rowIndex === 22 || rowIndex === 25  || rowIndex === 24 || rowIndex === 27 ||rowIndex === 31 || rowIndex === 32 ||rowIndex === 34  || rowIndex === 36 ||rowIndex === 38  || rowIndex === 39 || rowIndex === 40 || rowIndex === 41 || rowIndex === 42 || rowIndex === 44 || rowIndex === 45 || rowIndex === 47 || rowIndex === 48) continue;

  const cellD = worksheet.getCell(`G${rowIndex}`);
  cellD.value = columnFValues[valueIndex++];

  if (rowIndex === 50) {
    cellD.font = headerStyle.font;
    cellD.fill = cellStyle.fill;
  } else {
    cellD.font = cellStyle.font;
    cellD.fill = plannedcellstyle.fill;
  }

  cellD.alignment = cellStyle.alignment;
  cellD.border = cellStyle.border;
}



   


    let columnIValues = []
    // Define the values to fill in column H
  if (id?.id == "688716b052a839aadb5234ca") {
      columnIValues = [12,12,8,1,8,5,2,5,17,16,10,10,6,8,5,7,22,7,7,4,10,16,6,10,5,33,220]
    }
   
    // Fill values in column G only if the corresponding cell in column C is not empty
    let valueIndexI = 0;
    for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
      if (rowIndex === 12 ||  rowIndex === 15 || rowIndex === 19 ||rowIndex === 22 || rowIndex === 25  || rowIndex === 24 || rowIndex === 27 ||rowIndex === 31 || rowIndex === 32 ||rowIndex === 34  || rowIndex === 36 ||rowIndex === 38  || rowIndex === 39 || rowIndex === 40 || rowIndex === 41 || rowIndex === 42 || rowIndex === 44 || rowIndex === 45 || rowIndex === 47 || rowIndex === 48) continue;

        const cellD = worksheet.getCell(`J${rowIndex}`);
        cellD.value = columnIValues[valueIndexI++];
        if (rowIndex == 50) {
          cellD.font = headerStyle.font
          cellD.fill = cellStyle.fill;
        }
        else {

          cellD.font = cellStyle.font;


          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      
    }

    

    let columnLValues = []
    // Define the values to fill in column H
  if (id?.id == "688716b052a839aadb5234ca") {
      columnLValues = [12,12,8,1,8,5,2,5,17,16,10,10,6,8,5,7,22,7,7,4,10,16,6,10,5,33,220]
    }
   
    // Fill values in column G only if the corresponding cell in column C is not empty
    let valueIndexL = 0;
    for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
        if (rowIndex === 12 ||  rowIndex === 15 || rowIndex === 19 ||rowIndex === 22 || rowIndex === 25  ||  rowIndex === 24 || rowIndex === 27 ||rowIndex === 31 || rowIndex === 32 ||rowIndex === 34  || rowIndex === 36 ||rowIndex === 38  || rowIndex === 39 || rowIndex === 40 || rowIndex === 41 || rowIndex === 42 || rowIndex === 44 || rowIndex === 45 || rowIndex === 47 || rowIndex === 48) continue;

       const cellD = worksheet.getCell(`M${rowIndex}`);
        cellD.value = columnLValues[valueIndexL++];
        if ( rowIndex == 50) {
          cellD.font = headerStyle.font
          cellD.fill = cellStyle.fill;
        }
        else {

          cellD.font = cellStyle.font;


          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      
    }

    

    let columnOValues = []
    // Define the values to fill in column H
  if (id?.id == "688716b052a839aadb5234ca") {
      columnOValues = [12,12,8,1,8,5,2,5,17,16,10,10,6,8,5,7,22,7,7,4,10,16,6,10,5,33,220]
    }
   
    // Fill values in column G only if the corresponding cell in column C is not empty
    let valueIndexO = 0;
    for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
        if (rowIndex === 12 ||  rowIndex === 15 || rowIndex === 19 ||rowIndex === 22 || rowIndex === 25  || rowIndex === 24 || rowIndex === 27 ||rowIndex === 31 || rowIndex === 32 ||rowIndex === 34  || rowIndex === 36 ||rowIndex === 38  || rowIndex === 39 || rowIndex === 40 || rowIndex === 41 || rowIndex === 42 || rowIndex === 44 || rowIndex === 45 || rowIndex === 47 || rowIndex === 48) continue;

        const cellD = worksheet.getCell(`P${rowIndex}`);
        cellD.value = columnOValues[valueIndexO++];
        if ( rowIndex == 50) {
          cellD.font = headerStyle.font
          cellD.fill = cellStyle.fill;
        }
        else {

          cellD.font = cellStyle.font;


          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
    
    }
    

    let columnRValues = []
    // Define the values to fill in column H
  if (id?.id == "688716b052a839aadb5234ca") {
      columnRValues = [12,12,8,1,8,5,2,5,17,16,10,10,6,8,5,7,22,7,7,4,10,16,6,10,5,33,220]
    }
   
    // Fill values in column G only if the corresponding cell in column C is not empty
    let valueIndexR = 0;
    for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
      if (rowIndex === 12 ||  rowIndex === 15 || rowIndex === 19 ||rowIndex === 22 || rowIndex === 25  || rowIndex === 24 || rowIndex === 27 ||rowIndex === 31 || rowIndex === 32 ||rowIndex === 34  || rowIndex === 36 ||rowIndex === 38  || rowIndex === 39 || rowIndex === 40 || rowIndex === 41 || rowIndex === 42 || rowIndex === 44 || rowIndex === 45 || rowIndex === 47 || rowIndex === 48) continue;

        const cellD = worksheet.getCell(`S${rowIndex}`);
        cellD.value = columnRValues[valueIndexR++];
        if (rowIndex == 50) {
          cellD.font = headerStyle.font
          cellD.fill = cellStyle.fill;
        }
        else {

          cellD.font = cellStyle.font;


          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      
    }



    let columnUValues = []
    // Define the values to fill in column H
  if (id?.id == "688716b052a839aadb5234ca") {
      columnUValues = [12,12,8,1,8,5,2,5,17,16,10,10,6,8,5,7,22,7,7,4,10,16,6,10,5,33,220]
    }
   
    // Fill values in column G only if the corresponding cell in column C is not empty
    let valueIndexU = 0;
    for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
        if (rowIndex === 12 ||  rowIndex === 15 || rowIndex === 19 ||rowIndex === 22 || rowIndex === 25  ||  rowIndex === 24 || rowIndex === 27 ||rowIndex === 31 || rowIndex === 32 ||rowIndex === 34  || rowIndex === 36 ||rowIndex === 38  || rowIndex === 39 || rowIndex === 40 || rowIndex === 41 || rowIndex === 42 || rowIndex === 44 || rowIndex === 45 || rowIndex === 47 || rowIndex === 48) continue;

        const cellD = worksheet.getCell(`V${rowIndex}`);
        cellD.value = columnUValues[valueIndexU++];
        if ( rowIndex == 50) {
          cellD.font = headerStyle.font
          cellD.fill = cellStyle.fill;
        }
        else {

          cellD.font = cellStyle.font;


          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      
    }


    let columnXValues = []
    // Define the values to fill in column H
  if (id?.id == "688716b052a839aadb5234ca") {
      columnXValues = [12,12,8,1,8,5,2,5,17,16,10,10,6,8,5,7,22,7,7,4,10,16,6,10,5,33,220]
    }
   
    // Fill values in column G only if the corresponding cell in column C is not empty
    let valueIndexX = 0;
    for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
        if (rowIndex === 12 ||  rowIndex === 15 || rowIndex === 19 ||rowIndex === 22 || rowIndex === 25  ||  rowIndex === 24 || rowIndex === 27 ||rowIndex === 31 || rowIndex === 32 ||rowIndex === 34  || rowIndex === 36 ||rowIndex === 38  || rowIndex === 39 || rowIndex === 40 || rowIndex === 41 || rowIndex === 42 || rowIndex === 44 || rowIndex === 45 || rowIndex === 47 || rowIndex === 48) continue;

        const cellD = worksheet.getCell(`Y${rowIndex}`);
        cellD.value = columnXValues[valueIndexX++];
        if ( rowIndex == 50) {
          cellD.font = headerStyle.font
          cellD.fill = cellStyle.fill;
        }
        else {

          cellD.font = cellStyle.font;


          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      
    }

      let columnAAValues = []
    // Define the values to fill in column H
  if (id?.id == "688716b052a839aadb5234ca") {
      columnAAValues = [12,12,8,1,8,5,2,5,17,16,10,10,6,8,5,7,22,7,7,4,10,16,6,10,5,33,220]
    }
   
    // Fill values in column G only if the corresponding cell in column C is not empty
    let valueIndexAA = 0;
    for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
        if (rowIndex === 12 ||  rowIndex === 15 || rowIndex === 19 ||rowIndex === 22 || rowIndex === 25  ||  rowIndex === 24 || rowIndex === 27 ||rowIndex === 31 || rowIndex === 32 ||rowIndex === 34  || rowIndex === 36 ||rowIndex === 38  || rowIndex === 39 || rowIndex === 40 || rowIndex === 41 || rowIndex === 42 || rowIndex === 44 || rowIndex === 45 || rowIndex === 47 || rowIndex === 48) continue;

        const cellD = worksheet.getCell(`AB${rowIndex}`);
        cellD.value = columnAAValues[valueIndexAA++];
        if (rowIndex == 50) {
          cellD.font = headerStyle.font
          cellD.fill = cellStyle.fill;
        }
        else {

          cellD.font = cellStyle.font;


          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      
    }

      let columnADValues = []
    // Define the values to fill in column H
  if (id?.id == "688716b052a839aadb5234ca") {
      columnADValues = [12,12,8,1,8,5,2,5,17,16,10,10,6,8,5,7,22,7,7,4,10,16,6,10,5,33,220]
    }
   
    // Fill values in column G only if the corresponding cell in column C is not empty
    let valueIndexAD = 0;
    for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
        if (rowIndex === 12 ||  rowIndex === 15 || rowIndex === 19 ||rowIndex === 22 || rowIndex === 25  ||  rowIndex === 24 || rowIndex === 27 ||rowIndex === 31 || rowIndex === 32 ||rowIndex === 34  || rowIndex === 36 ||rowIndex === 38  || rowIndex === 39 || rowIndex === 40 || rowIndex === 41 || rowIndex === 42 || rowIndex === 44 || rowIndex === 45 || rowIndex === 47 || rowIndex === 48) continue;

        const cellD = worksheet.getCell(`AE${rowIndex}`);
        cellD.value = columnADValues[valueIndexAD++];
        if ( rowIndex == 50) {
          cellD.font = headerStyle.font
          cellD.fill = cellStyle.fill;
        }
        else {

          cellD.font = cellStyle.font;


          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      
    }


      let columnAGValues = []
    // Define the values to fill in column H
  if (id?.id == "688716b052a839aadb5234ca") {
      columnAGValues = [12,12,8,1,8,5,2,5,17,16,10,10,6,8,5,7,22,7,7,4,10,16,6,10,5,33,220]
    }
   
    // Fill values in column G only if the corresponding cell in column C is not empty
    let valueIndexAG = 0;
    for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
        if ( rowIndex === 12 ||  rowIndex === 15 || rowIndex === 19 ||rowIndex === 22 || rowIndex === 25  ||  rowIndex === 24 || rowIndex === 27 ||rowIndex === 31 || rowIndex === 32 ||rowIndex === 34  || rowIndex === 36 ||rowIndex === 38  || rowIndex === 39 || rowIndex === 40 || rowIndex === 41 || rowIndex === 42 || rowIndex === 44 || rowIndex === 45 || rowIndex === 47 || rowIndex === 48) continue;

       const cellD = worksheet.getCell(`AH${rowIndex}`);
        cellD.value = columnAGValues[valueIndexAG++];
        if ( rowIndex == 50) {
          cellD.font = headerStyle.font
          cellD.fill = cellStyle.fill;
        }
        else {

          cellD.font = cellStyle.font;


          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      
    }


    
      let columnAJValues = []
    // Define the values to fill in column H
  if (id?.id == "688716b052a839aadb5234ca") {
      columnAJValues =[12,12,8,1,8,5,2,5,17,16,10,10,6,8,5,7,22,7,7,4,10,16,6,10,5,33,220]
    }
   
    // Fill values in column G only if the corresponding cell in column C is not empty
    let valueIndexAJ = 0;
    for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
        if (rowIndex === 12 ||  rowIndex === 15 || rowIndex === 19 ||rowIndex === 22 || rowIndex === 25  ||  rowIndex === 24 || rowIndex === 27 ||rowIndex === 31 || rowIndex === 32 ||rowIndex === 34  || rowIndex === 36 ||rowIndex === 38  || rowIndex === 39 || rowIndex === 40 || rowIndex === 41 || rowIndex === 42 || rowIndex === 44 || rowIndex === 45 || rowIndex === 47 || rowIndex === 48) continue;

       const cellD = worksheet.getCell(`AK${rowIndex}`);
        cellD.value = columnAJValues[valueIndexAJ++];
        if (rowIndex == 50) {
          cellD.font = headerStyle.font
          cellD.fill = cellStyle.fill;
        }
        else {

          cellD.font = cellStyle.font;


          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      
    }



      let columnAMValues = []
    // Define the values to fill in column H
  if (id?.id == "688716b052a839aadb5234ca") {
      columnAMValues = [12,12,8,1,8,5,2,5,17,16,10,10,6,8,5,7,22,7,7,4,10,16,6,10,5,33,220]
    }
   
    // Fill values in column G only if the corresponding cell in column C is not empty
    let valueIndexAM = 0;
    for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
        if ( rowIndex === 12 ||  rowIndex === 15 || rowIndex === 19 ||rowIndex === 22 || rowIndex === 25  ||  rowIndex === 24 || rowIndex === 27 ||rowIndex === 31 || rowIndex === 32 ||rowIndex === 34  || rowIndex === 36 ||rowIndex === 38  || rowIndex === 39 || rowIndex === 40 || rowIndex === 41 || rowIndex === 42 || rowIndex === 44 || rowIndex === 45 || rowIndex === 47 || rowIndex === 48) continue;

        const cellD = worksheet.getCell(`AN${rowIndex}`);
        cellD.value = columnAMValues[valueIndexAM++];
        if (rowIndex == 50) {
          cellD.font = headerStyle.font
          cellD.fill = cellStyle.fill;
        }
        else {

          cellD.font = cellStyle.font;


          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      
    }

      let columnAPValues = []
    // Define the values to fill in column H
  if (id?.id == "688716b052a839aadb5234ca") {
      columnAPValues = [12,12,8,1,8,5,2,5,17,16,10,10,6,8,5,7,22,7,7,4,10,16,6,10,5,33,220]
    }
   
    // Fill values in column G only if the corresponding cell in column C is not empty
    let valueIndexAP = 0;
    for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
        if (rowIndex === 12 ||  rowIndex === 15 || rowIndex === 19 ||rowIndex === 22 || rowIndex === 25  ||  rowIndex === 24 || rowIndex === 27 ||rowIndex === 31 || rowIndex === 32 ||rowIndex === 34  || rowIndex === 36 ||rowIndex === 38  || rowIndex === 39 || rowIndex === 40 || rowIndex === 41 || rowIndex === 42 || rowIndex === 44 || rowIndex === 45 || rowIndex === 47 || rowIndex === 48) continue;

        const cellD = worksheet.getCell(`AQ${rowIndex}`);
        cellD.value = columnAPValues[valueIndexAP++];
        if ( rowIndex == 50) {
          cellD.font = headerStyle.font
          cellD.fill = cellStyle.fill;
        }
        else {

          cellD.font = cellStyle.font;


          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      
    }

      let columnASValues = []
    // Define the values to fill in column H
  if (id?.id == "688716b052a839aadb5234ca") {
      columnASValues = [12,12,8,1,8,5,2,5,17,16,10,10,6,8,5,7,22,7,7,4,10,16,6,10,5,33,220]
    }
   
    // Fill values in column G only if the corresponding cell in column C is not empty
    let valueIndexAS = 0;
    for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
        if (rowIndex === 12 ||  rowIndex === 15 || rowIndex === 19 ||rowIndex === 22 || rowIndex === 25  ||  rowIndex === 24 || rowIndex === 27 ||rowIndex === 31 || rowIndex === 32 ||rowIndex === 34  || rowIndex === 36 ||rowIndex === 38  || rowIndex === 39 || rowIndex === 40 || rowIndex === 41 || rowIndex === 42 || rowIndex === 44 || rowIndex === 45 || rowIndex === 47 || rowIndex === 48) continue;

        const cellD = worksheet.getCell(`AT${rowIndex}`);
        cellD.value = columnASValues[valueIndexAS++];
        if ( rowIndex == 50) {
          cellD.font = headerStyle.font
          cellD.fill = cellStyle.fill;
        }
        else {

          cellD.font = cellStyle.font;


          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      
    }

      let columnAVValues = []
    // Define the values to fill in column H
  if (id?.id == "688716b052a839aadb5234ca") {
      columnAVValues = [12,12,8,1,8,5,2,5,17,16,10,10,6,8,5,7,22,7,7,4,10,16,6,10,5,33,220]
    }
   
    // Fill values in column G only if the corresponding cell in column C is not empty
    let valueIndexAV = 0;
    for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
        if (rowIndex === 12 ||  rowIndex === 15 || rowIndex === 19 ||rowIndex === 22 || rowIndex === 25  ||   rowIndex === 24 || rowIndex === 27 ||rowIndex === 31 || rowIndex === 32 ||rowIndex === 34  || rowIndex === 36 ||rowIndex === 38  || rowIndex === 39 || rowIndex === 40 || rowIndex === 41 || rowIndex === 42 || rowIndex === 44 || rowIndex === 45 || rowIndex === 47 || rowIndex === 48) continue;

       const cellD = worksheet.getCell(`AW${rowIndex}`);
        cellD.value = columnAVValues[valueIndexAV++];
        if ( rowIndex == 50) {
          cellD.font = headerStyle.font
          cellD.fill = cellStyle.fill;
        }
        else {

          cellD.font = cellStyle.font;


          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      
    }
      let columnAYValues = []
    // Define the values to fill in column H
  if (id?.id == "688716b052a839aadb5234ca") {
      columnAYValues = [6,6,3,1,3,3,1,3,9,8,5,5,3,4,3,3,12,4,4,2,3,9,3,5,3,33,110]
    }
   
    // Fill values in column G only if the corresponding cell in column C is not empty
    let valueIndexAY = 0;
    for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
        if ( rowIndex === 12 ||  rowIndex === 15 || rowIndex === 19 ||rowIndex === 22 || rowIndex === 25  ||  rowIndex === 24 || rowIndex === 27 ||rowIndex === 31 || rowIndex === 32 ||rowIndex === 34  || rowIndex === 36 ||rowIndex === 38  || rowIndex === 39 || rowIndex === 40 || rowIndex === 41 || rowIndex === 42 || rowIndex === 44 || rowIndex === 45 || rowIndex === 47 || rowIndex === 48) continue;

        const cellD = worksheet.getCell(`AZ${rowIndex}`);
        cellD.value = columnAYValues[valueIndexAY++];
        if (rowIndex == 50) {
          cellD.font = headerStyle.font
          cellD.fill = cellStyle.fill;
        }
        else {

          cellD.font = cellStyle.font;


          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      
    }


    let columnBBValues = []
    // Define the values to fill in column H
  if (id?.id == "688716b052a839aadb5234ca") {
      columnBBValues = [6,6,3,1,3,3,1,3,9,8,5,5,3,4,3,3,12,4,4,2,3,9,3,5,3,33,110]
    }
   
    // Fill values in column G only if the corresponding cell in column C is not empty
    let valueIndexBB = 0;
    for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
        if (rowIndex === 12 ||  rowIndex === 15 || rowIndex === 19 ||rowIndex === 22 || rowIndex === 25  ||   rowIndex === 24 || rowIndex === 27 ||rowIndex === 31 || rowIndex === 32 ||rowIndex === 34  || rowIndex === 36 ||rowIndex === 38  || rowIndex === 39 || rowIndex === 40 || rowIndex === 41 || rowIndex === 42 || rowIndex === 44 || rowIndex === 45 || rowIndex === 47 || rowIndex === 48) continue;

        const cellD = worksheet.getCell(`BC${rowIndex}`);
        cellD.value = columnBBValues[valueIndexBB++];
        if (rowIndex == 50) {
          cellD.font = headerStyle.font
          cellD.fill = cellStyle.fill;
        }
        else {

          cellD.font = cellStyle.font;


          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      
    }

let columnBEValues = []
    // Define the values to fill in column H
  if (id?.id == "688716b052a839aadb5234ca") {
      columnBEValues =  [6,6,3,1,3,3,1,3,9,8,5,5,3,4,3,3,12,4,4,2,3,9,3,5,3,33,110]
    }
   
    // Fill values in column G only if the corresponding cell in column C is not empty
    let valueIndexBE = 0;
    for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
        if (rowIndex === 12 ||  rowIndex === 15 || rowIndex === 19 ||rowIndex === 22 || rowIndex === 25  ||  rowIndex === 24 || rowIndex === 27 ||rowIndex === 31 || rowIndex === 32 ||rowIndex === 34  || rowIndex === 36 ||rowIndex === 38  || rowIndex === 39 || rowIndex === 40 || rowIndex === 41 || rowIndex === 42 || rowIndex === 44 || rowIndex === 45 || rowIndex === 47 || rowIndex === 48) continue;

        const cellD = worksheet.getCell(`BF${rowIndex}`);
        cellD.value = columnBEValues[valueIndexBE++];
        if (rowIndex == 50) {
          cellD.font = headerStyle.font
          cellD.fill = cellStyle.fill;
        }
        else {

          cellD.font = cellStyle.font;


          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      
    }

    let columnBHValues = []
    // Define the values to fill in column H
  if (id?.id == "688716b052a839aadb5234ca") {
      columnBHValues =  [6,6,3,1,3,3,1,3,9,8,5,5,3,4,3,3,12,4,4,2,3,9,3,5,3,33,110]
    }
   
    // Fill values in column G only if the corresponding cell in column C is not empty
    let valueIndexBH = 0;
    for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
        if ( rowIndex === 12 ||  rowIndex === 15 || rowIndex === 19 ||rowIndex === 22 || rowIndex === 25  ||  rowIndex === 24 || rowIndex === 27 ||rowIndex === 31 || rowIndex === 32 ||rowIndex === 34  || rowIndex === 36 ||rowIndex === 38  || rowIndex === 39 || rowIndex === 40 || rowIndex === 41 || rowIndex === 42 || rowIndex === 44 || rowIndex === 45 || rowIndex === 47 || rowIndex === 48) continue;

        const cellD = worksheet.getCell(`BI${rowIndex}`);
        cellD.value = columnBHValues[valueIndexBH++];
        if ( rowIndex == 50) {
          cellD.font = headerStyle.font
          cellD.fill = cellStyle.fill;
        }
        else {

          cellD.font = cellStyle.font;


          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      
    }



    let columnBKValues = []
    // Define the values to fill in column H
  if (id?.id == "688716b052a839aadb5234ca") {
      columnBKValues = [6,6,3,1,3,3,1,3,9,8,5,5,3,4,3,3,12,4,4,2,3,9,3,5,3,33,110]
    }
   
    // Fill values in column G only if the corresponding cell in column C is not empty
    let valueIndexBK = 0;
    for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
        if ( rowIndex === 12 ||  rowIndex === 15 || rowIndex === 19 ||rowIndex === 22 || rowIndex === 25  ||  rowIndex === 24 || rowIndex === 27 ||rowIndex === 31 || rowIndex === 32 ||rowIndex === 34  || rowIndex === 36 ||rowIndex === 38  || rowIndex === 39 || rowIndex === 40 || rowIndex === 41 || rowIndex === 42 || rowIndex === 44 || rowIndex === 45 || rowIndex === 47 || rowIndex === 48) continue;

        const cellD = worksheet.getCell(`BL${rowIndex}`);
        cellD.value = columnBKValues[valueIndexBK++];
        if (rowIndex == 50) {
          cellD.font = headerStyle.font
          cellD.fill = cellStyle.fill;
        }
        else {

          cellD.font = cellStyle.font;


          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      
    }


    let columnBNValues = []
    // Define the values to fill in column H
  if (id?.id == "688716b052a839aadb5234ca") {
      columnBNValues =  [6,6,3,1,3,3,1,3,9,8,5,5,3,4,3,3,12,4,4,2,3,9,3,5,3,33,110]
    }
   
    // Fill values in column G only if the corresponding cell in column C is not empty
    let valueIndexBN = 0;
    for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
        if (rowIndex === 12 ||  rowIndex === 15 || rowIndex === 19 ||rowIndex === 22 || rowIndex === 25  ||   rowIndex === 24 || rowIndex === 27 ||rowIndex === 31 || rowIndex === 32 ||rowIndex === 34  || rowIndex === 36 ||rowIndex === 38  || rowIndex === 39 || rowIndex === 40 || rowIndex === 41 || rowIndex === 42 || rowIndex === 44 || rowIndex === 45 || rowIndex === 47 || rowIndex === 48) continue;

        const cellD = worksheet.getCell(`BO${rowIndex}`);
        cellD.value = columnBNValues[valueIndexBN++];
        if (rowIndex == 50) {
          cellD.font = headerStyle.font
          cellD.fill = cellStyle.fill;
        }
        else {

          cellD.font = cellStyle.font;


          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      
    }


    let columnBQValues = []
    // Define the values to fill in column H
  if (id?.id == "688716b052a839aadb5234ca") {
      columnBQValues =  [6,6,3,1,3,3,1,3,9,8,5,5,3,4,3,3,12,4,4,2,3,9,3,5,3,33,110]
    }
   
    // Fill values in column G only if the corresponding cell in column C is not empty
    let valueIndexBQ = 0;
    for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
        if ( rowIndex === 12 ||  rowIndex === 15 || rowIndex === 19 ||rowIndex === 22 || rowIndex === 25  ||  rowIndex === 24 || rowIndex === 27 ||rowIndex === 31 || rowIndex === 32 ||rowIndex === 34  || rowIndex === 36 ||rowIndex === 38  || rowIndex === 39 || rowIndex === 40 || rowIndex === 41 || rowIndex === 42 || rowIndex === 44 || rowIndex === 45 || rowIndex === 47 || rowIndex === 48) continue;

        const cellD = worksheet.getCell(`BR${rowIndex}`);
        cellD.value = columnBQValues[valueIndexBQ++];
        if ( rowIndex == 50) {
          cellD.font = headerStyle.font
          cellD.fill = cellStyle.fill;
        }
        else {

          cellD.font = cellStyle.font;


          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      
    }

    let columnBTValues = []
    // Define the values to fill in column H
  if (id?.id == "688716b052a839aadb5234ca") {
      columnBTValues =  [6,6,3,1,3,3,1,3,9,8,5,5,3,4,3,3,12,4,4,2,3,9,3,5,3,33,110]
    }
   
    // Fill values in column G only if the corresponding cell in column C is not empty
    let valueIndexBT = 0;
    for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
        if (rowIndex === 12 ||  rowIndex === 15 || rowIndex === 19 ||rowIndex === 22 || rowIndex === 25  ||  rowIndex === 24 || rowIndex === 27 ||rowIndex === 31 || rowIndex === 32 ||rowIndex === 34  || rowIndex === 36 ||rowIndex === 38  || rowIndex === 39 || rowIndex === 40 || rowIndex === 41 || rowIndex === 42 || rowIndex === 44 || rowIndex === 45 || rowIndex === 47 || rowIndex === 48) continue;

        const cellD = worksheet.getCell(`BU${rowIndex}`);
        cellD.value = columnBTValues[valueIndexBT++];
        if ( rowIndex == 50) {
          cellD.font = headerStyle.font
          cellD.fill = cellStyle.fill;
        }
        else {

          cellD.font = cellStyle.font;


          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      
    }

    let columnBWValues = []
    // Define the values to fill in column H
  if (id?.id == "688716b052a839aadb5234ca") {
      columnBWValues =  [6,6,3,1,3,3,1,3,9,8,5,5,3,4,3,3,12,4,4,2,3,9,3,5,3,33,110]
    }
   
    // Fill values in column G only if the corresponding cell in column C is not empty
    let valueIndexBW = 0;
    for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
        if (rowIndex === 12 ||  rowIndex === 15 || rowIndex === 19 ||rowIndex === 22 || rowIndex === 25  ||  rowIndex === 24 || rowIndex === 27 ||rowIndex === 31 || rowIndex === 32 ||rowIndex === 34  || rowIndex === 36 ||rowIndex === 38  || rowIndex === 39 || rowIndex === 40 || rowIndex === 41 || rowIndex === 42 || rowIndex === 44 || rowIndex === 45 || rowIndex === 47 || rowIndex === 48) continue;

        const cellD = worksheet.getCell(`BX${rowIndex}`);
        cellD.value = columnBWValues[valueIndexBW++];
        if ( rowIndex == 50) {
          cellD.font = headerStyle.font
          cellD.fill = cellStyle.fill;
        }
        else {

          cellD.font = cellStyle.font;


          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      
    }

    let columnBZValues = []
    // Define the values to fill in column H
  if (id?.id == "688716b052a839aadb5234ca") {
      columnBZValues =  [6,6,3,1,3,3,1,3,9,8,5,5,3,4,3,3,12,4,4,2,3,9,3,5,3,33,110]
    }
   
    // Fill values in column G only if the corresponding cell in column C is not empty
    let valueIndexBZ = 0;
    for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
        if (rowIndex === 12 ||  rowIndex === 15 || rowIndex === 19 ||rowIndex === 22 || rowIndex === 25  ||  rowIndex === 24 || rowIndex === 27 ||rowIndex === 31 || rowIndex === 32 ||rowIndex === 34  || rowIndex === 36 ||rowIndex === 38  || rowIndex === 39 || rowIndex === 40 || rowIndex === 41 || rowIndex === 42 || rowIndex === 44 || rowIndex === 45 || rowIndex === 47 || rowIndex === 48) continue;

        const cellD = worksheet.getCell(`CA${rowIndex}`);
        cellD.value = columnBZValues[valueIndexBZ++];
        if ( rowIndex == 50) {
          cellD.font = headerStyle.font
          cellD.fill = cellStyle.fill;
        }
        else {

          cellD.font = cellStyle.font;


          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      
    }



    const isCriterionMet = (answer, criterion) => {
        if (Array.isArray(criterion)) {
          return criterion.some(crit => Array.isArray(answer) ? answer.includes(crit) : answer === crit);
        } else {
          if (Array.isArray(answer)) {
            return answer.includes(criterion) ||
                   (criterion === 'Rs. 10-15 lakh per annum' && answer.includes('More than Rs. 15 lakh per annum')) ||
                   (criterion === 'Other' && answer.some(ans => ans.includes('Other:')));
          } else {
            return answer === criterion ||
                   (criterion === 'Rs. 10-15 lakh per annum' && answer === 'More than Rs. 15 lakh per annum') ||
                   (criterion === 'Other' && answer?.includes('Other:'));
          }
        }
      };
    
      
     
      
    
      // Updated countMatches function to incorporate the new logic
      const countMatches = (criteria) => {
        return dashboardData.filter(response =>
          criteria.every(criterion =>
            Array.isArray(criterion) ? criterion.some(subCriterion =>
              response.questions.some(q => isQuestionInCheckArray(q.question) && isCriterionMet(q.answer, subCriterion))
            ) :
              response.questions.some(q => isQuestionInCheckArray(q.question) && isCriterionMet(q.answer, criterion))
          )
        ).length;
      };
    
      
      const criteriaMap = {
        4: ['Kirana/Grocery store', 'Delhi'],
        5: ['Fruit / Vegetable Vendors', 'Delhi'],
        6: ['Stationery / General Stores', 'Delhi'],
        7: ['Meat / Fish Shops', 'Delhi'],
        8: ['Sweet Shops/Mithai Shop', 'Delhi'],
        9: ['Ice Cream / Dessert Parlors', 'Delhi'],
        10: ['Departmental store/Supermarket/Walmart/Dmart', 'Delhi'],
        11: ['Bakery', 'Delhi', ],
        13: ['Tea/Coffee stall', 'Delhi'],
        14: ['Pan/Cigarette/Beedi Shop', 'Delhi'],
        16: ['Street food vendors', 'Delhi'],
        17: ['Restaurants / Dhabas/Café/Chains', 'Delhi'],
        18: ['Juice / Coconut Water Vendors', 'Delhi'],
        20: ['LPG/CNG/Gas/Fuel (Diesel/Petrol) Stations', 'Delhi'],
        21: ['Car / Bike Workshops/Repair Shop', 'Delhi'],
        23: [['Smartphone Retail shop /VI/Airtel/jio Stores','Cyber Cafes / Photocopy Shops','Smartphone Retail shop /VI/Airtel/jio Stores/Cyber Cafes / Photocopy Shops'],'Delhi'],
        // 20: ['Cyber Cafes / Photocopy Shops', 'Delhi'],
        26: ['Dairy', 'Delhi'],
        28: ['Branded Clothing Store', 'Delhi'],
        29: ['Men’s and women’s clothing shops', 'Delhi'],
        30: ['Tailor shop', 'Delhi'],
        32: [['Chemists / Medical Stores/Pathology Labs','Hospitals/Clinics / Doctors','Chemists / Medical Stores/Pathology Labs/Hospitals/Clinics / Doctors'], 'Delhi'],
        35: ['Salons / Beauty Parlours/ Beauty and barber shops', 'Delhi'],
        37: [['Auto Rickshaws/Bike Taxis/Cab Operators','Porter/Uber/Ola/Rapido','Travel/Railway/Metro/Bus','Auto Rickshaws/Bike Taxis/Cab Operators/ Porter / Uber / Ola / Rapido / Travel / Railway / Metro / Bus'], 'Delhi'],
        41: [['Consumer Durables/Home Appliance/Electronic Stores (TV, Mixer, etc.)','Electrical/ Plumbing/Hardware Stores','Electronics Repair Shops/ Mobile Repair/Accessory Shops','Consumer Durables/Home Appliance Stores (TV, Mixer, etc.)/Electrical/ Plumbing/Hardware Stores/Electrical/ Plumbing/Hardware Stores'], 'Delhi'],
        44: ['Beer, wine, liquor shop', 'Delhi'],
        47: [['Premium Category Including Airport stores, Malls, Jewellery stores, educational institutions, hotel & lodging chains & standalones','Airport stores, Malls,Jewellery stores, educational institutions, hotel & lodging chains & standalones Jewellery stores, educational institutions, hotel & lodging chains & standalones'], 'Delhi'],
       
       
      };
    
      Object.keys(criteriaMap).forEach(rowIndex => {
        const criteria = criteriaMap[rowIndex];
        const count = countMatches(criteria);
        const cellH = worksheet.getCell(`H${rowIndex}`);
        cellH.value = count;
        if (rowIndex == 12 || rowIndex == 15 || rowIndex == 19 || rowIndex == 22 || rowIndex == 25 || rowIndex == 31 || rowIndex == 34 ||rowIndex == 36 || rowIndex == 40 ) {
          cellH.font = headerStyle.font
          cellH.fill = headerStyle.fill;
          cellH.alignment = headerStyle.alignment;
        cellH.border = headerStyle.border;
        }
       
        else{
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      }
      });
    
      // --------jaipur------- (For Credit Cards)
       const criteriaMapJaipur = {
        4: ['Kirana/Grocery store', 'Jaipur'],
        5: ['Fruit / Vegetable Vendors', 'Jaipur'],
        6: ['Stationery / General Stores', 'Jaipur'],
        7: ['Meat / Fish Shops', 'Jaipur'],
        8: ['Sweet Shops/Mithai Shop', 'Jaipur'],
        9: ['Ice Cream / Dessert Parlors', 'Jaipur'],
        10: ['Departmental store/Supermarket/Walmart/Dmart', 'Jaipur'],
        11: ['Bakery', 'Jaipur', ],
        13: ['Tea/Coffee stall', 'Jaipur'],
        14: ['Pan/Cigarette/Beedi Shop', 'Jaipur'],
        16: ['Street food vendors', 'Jaipur'],
        17: ['Restaurants / Dhabas/Café/Chains', 'Jaipur'],
        18: ['Juice / Coconut Water Vendors', 'Jaipur'],
        20: ['LPG/CNG/Gas/Fuel (Diesel/Petrol) Stations', 'Jaipur'],
        21: ['Car / Bike Workshops/Repair Shop', 'Jaipur'],
        23: [['Smartphone Retail shop /VI/Airtel/jio Stores','Cyber Cafes / Photocopy Shops','Smartphone Retail shop /VI/Airtel/jio Stores/Cyber Cafes / Photocopy Shops'],'Jaipur'],
        // 20: ['Cyber Cafes / Photocopy Shops', 'Jaipur'],
       26: ['Dairy', 'Jaipur'],
        28: ['Branded Clothing Store', 'Jaipur'],
        29: ['Men’s and women’s clothing shops', 'Jaipur'],
        30: ['Tailor shop', 'Jaipur'],
        32: [['Chemists / Medical Stores/Pathology Labs','Hospitals/Clinics / Doctors','Chemists / Medical Stores/Pathology Labs/Hospitals/Clinics / Doctors'], 'Jaipur'],
        35: ['Salons / Beauty Parlours/ Beauty and barber shops', 'Jaipur'],
        37: [['Auto Rickshaws/Bike Taxis/Cab Operators','Porter/Uber/Ola/Rapido','Travel/Railway/Metro/Bus','Auto Rickshaws/Bike Taxis/Cab Operators/ Porter / Uber / Ola / Rapido / Travel / Railway / Metro / Bus'], 'Jaipur'],
        41: [['Consumer Durables/Home Appliance/Electronic Stores (TV, Mixer, etc.)','Electrical/ Plumbing/Hardware Stores','Electronics Repair Shops/ Mobile Repair/Accessory Shops','Consumer Durables/Home Appliance Stores (TV, Mixer, etc.)/Electrical/ Plumbing/Hardware Stores/Electrical/ Plumbing/Hardware Stores'], 'Jaipur'],
        44: ['Beer, wine, liquor shop', 'Jaipur'],
       47: [['Premium Category Including Airport stores, Malls, Jewellery stores, educational institutions, hotel & lodging chains & standalones','Airport stores, Malls,Jewellery stores, educational institutions, hotel & lodging chains & standalones Jewellery stores, educational institutions, hotel & lodging chains & standalones'], 'Jaipur'],
      };
    
      Object.keys(criteriaMapJaipur).forEach(rowIndex => {
        const criteria = criteriaMapJaipur[rowIndex];
        const count = countMatches(criteria);
        const cellH = worksheet.getCell(`K${rowIndex}`);
        cellH.value = count;
        console.log(`Jaipur Row ${rowIndex}: ${count} (${criteria.join(', ')})`);
         if (rowIndex == 12 || rowIndex == 15 || rowIndex == 19 || rowIndex == 22 || rowIndex == 25 || rowIndex == 31 || rowIndex == 34 ||rowIndex == 36 || rowIndex == 40 ) {
          cellH.font = headerStyle.font
          cellH.fill = headerStyle.fill;
          cellH.alignment = headerStyle.alignment;
        cellH.border = headerStyle.border;
        }
        else{
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      }
      });
    
      const criteriaMapLucknow = {
        4: ['Kirana/Grocery store', 'Lucknow'],
        5: ['Fruit / Vegetable Vendors', 'Lucknow'],
        6: ['Stationery / General Stores', 'Lucknow'],
        7: ['Meat / Fish Shops', 'Lucknow'],
        8: ['Sweet Shops/Mithai Shop', 'Lucknow'],
        9: ['Ice Cream / Dessert Parlors', 'Lucknow'],
        10: ['Departmental store/Supermarket/Walmart/Dmart', 'Lucknow'],
        11: ['Bakery', 'Lucknow', ],
        13: ['Tea/Coffee stall', 'Lucknow'],
        14: ['Pan/Cigarette/Beedi Shop', 'Lucknow'],
        16: ['Street food vendors', 'Lucknow'],
        17: ['Restaurants / Dhabas/Café/Chains', 'Lucknow'],
        18: ['Juice / Coconut Water Vendors', 'Lucknow'],
        20: ['LPG/CNG/Gas/Fuel (Diesel/Petrol) Stations', 'Lucknow'],
        21: ['Car / Bike Workshops/Repair Shop', 'Lucknow'],
        23: [['Smartphone Retail shop /VI/Airtel/jio Stores','Cyber Cafes / Photocopy Shops','Smartphone Retail shop /VI/Airtel/jio Stores/Cyber Cafes / Photocopy Shops'],'Lucknow'],
        // 20: ['Cyber Cafes / Photocopy Shops', 'Lucknow'],
       26: ['Dairy', 'Lucknow'],
       28: ['Branded Clothing Store', 'Lucknow'],
        29: ['Men’s and women’s clothing shops', 'Lucknow'],
        30: ['Tailor shop', 'Lucknow'],
        32: [['Chemists / Medical Stores/Pathology Labs','Hospitals/Clinics / Doctors','Chemists / Medical Stores/Pathology Labs/Hospitals/Clinics / Doctors'], 'Lucknow'],
        35: ['Salons / Beauty Parlours/ Beauty and barber shops', 'Lucknow'],
       37: [['Auto Rickshaws/Bike Taxis/Cab Operators','Porter/Uber/Ola/Rapido','Travel/Railway/Metro/Bus','Auto Rickshaws/Bike Taxis/Cab Operators/ Porter / Uber / Ola / Rapido / Travel / Railway / Metro / Bus'], 'Lucknow'],
        41: [['Consumer Durables/Home Appliance/Electronic Stores (TV, Mixer, etc.)','Electrical/ Plumbing/Hardware Stores','Electronics Repair Shops/ Mobile Repair/Accessory Shops','Consumer Durables/Home Appliance Stores (TV, Mixer, etc.)/Electrical/ Plumbing/Hardware Stores/Electrical/ Plumbing/Hardware Stores'], 'Lucknow'],
        44: ['Beer, wine, liquor shop', 'Lucknow'],
        47: [['Premium Category Including Airport stores, Malls, Jewellery stores, educational institutions, hotel & lodging chains & standalones','Airport stores, Malls,Jewellery stores, educational institutions, hotel & lodging chains & standalones Jewellery stores, educational institutions, hotel & lodging chains & standalones'], 'Lucknow'],
      };
    
      Object.keys(criteriaMapLucknow).forEach(rowIndex => {
        const criteria = criteriaMapLucknow[rowIndex];
        const count = countMatches(criteria);
        const cellH = worksheet.getCell(`N${rowIndex}`);
        cellH.value = count;
        if (rowIndex == 12 || rowIndex == 15 || rowIndex == 19 || rowIndex == 22 || rowIndex == 25 || rowIndex == 31 || rowIndex == 34 ||rowIndex == 36 || rowIndex == 40 ) {
          cellH.font = headerStyle.font
          cellH.fill = headerStyle.fill;
          cellH.alignment = headerStyle.alignment;
        cellH.border = headerStyle.border;
        }
        else{
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      }
      });

      const criteriaMapKanpur = {
         4: ['Kirana/Grocery store', 'Kanpur'],
        5: ['Fruit / Vegetable Vendors', 'Kanpur'],
        6: ['Stationery / General Stores', 'Kanpur'],
        7: ['Meat / Fish Shops', 'Kanpur'],
        8: ['Sweet Shops/Mithai Shop', 'Kanpur'],
        9: ['Ice Cream / Dessert Parlors', 'Kanpur'],
        10: ['Departmental store/Supermarket/Walmart/Dmart', 'Kanpur'],
        11: ['Bakery', 'Kanpur', ],
        13: ['Tea/Coffee stall', 'Kanpur'],
        14: ['Pan/Cigarette/Beedi Shop', 'Kanpur'],
        16: ['Street food vendors', 'Kanpur'],
        17: ['Restaurants / Dhabas/Café/Chains', 'Kanpur'],
        18: ['Juice / Coconut Water Vendors', 'Kanpur'],
        20: ['LPG/CNG/Gas/Fuel (Diesel/Petrol) Stations', 'Kanpur'],
        21: ['Car / Bike Workshops/Repair Shop', 'Kanpur'],
        23: [['Smartphone Retail shop /VI/Airtel/jio Stores','Cyber Cafes / Photocopy Shops','Smartphone Retail shop /VI/Airtel/jio Stores/Cyber Cafes / Photocopy Shops'],'Kanpur'],
        // 20: ['Cyber Cafes / Photocopy Shops', 'Kanpur'],
       26: ['Dairy', 'Kanpur'],
       28: ['Branded Clothing Store', 'Kanpur'],
        29: ['Men’s and women’s clothing shops', 'Kanpur'],
        30: ['Tailor shop', 'Kanpur'],
        32: [['Chemists / Medical Stores/Pathology Labs','Hospitals/Clinics / Doctors','Chemists / Medical Stores/Pathology Labs/Hospitals/Clinics / Doctors'], 'Kanpur'],
        35: ['Salons / Beauty Parlours/ Beauty and barber shops', 'Kanpur'],
        37: [['Auto Rickshaws/Bike Taxis/Cab Operators','Porter/Uber/Ola/Rapido','Travel/Railway/Metro/Bus','Auto Rickshaws/Bike Taxis/Cab Operators/ Porter / Uber / Ola / Rapido / Travel / Railway / Metro / Bus'], 'Kanpur'],
        41: [['Consumer Durables/Home Appliance/Electronic Stores (TV, Mixer, etc.)','Electrical/ Plumbing/Hardware Stores','Electronics Repair Shops/ Mobile Repair/Accessory Shops','Consumer Durables/Home Appliance Stores (TV, Mixer, etc.)/Electrical/ Plumbing/Hardware Stores/Electrical/ Plumbing/Hardware Stores'], 'Kanpur'],
        44: ['Beer, wine, liquor shop', 'Kanpur'],
       47: [['Premium Category Including Airport stores, Malls, Jewellery stores, educational institutions, hotel & lodging chains & standalones','Airport stores, Malls,Jewellery stores, educational institutions, hotel & lodging chains & standalones Jewellery stores, educational institutions, hotel & lodging chains & standalones'], 'Kanpur'],
      };
      Object.keys(criteriaMapKanpur).forEach(rowIndex => {
        const criteria = criteriaMapKanpur[rowIndex];
        const count = countMatches(criteria);
        const cellH = worksheet.getCell(`Q${rowIndex}`);
        cellH.value = count;
         if (rowIndex == 12 || rowIndex == 15 || rowIndex == 19 || rowIndex == 22 || rowIndex == 25 || rowIndex == 31 || rowIndex == 34 ||rowIndex == 36 || rowIndex == 40 ) {
          cellH.font = headerStyle.font
          cellH.fill = headerStyle.fill;
          cellH.alignment = headerStyle.alignment;
        cellH.border = headerStyle.border;
        }
        else{
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      }
      });
    
        const criteriaMapBengaluru = {
         4: ['Kirana/Grocery store', 'Bengaluru'],
        5: ['Fruit / Vegetable Vendors', 'Bengaluru'],
        6: ['Stationery / General Stores', 'Bengaluru'],
        7: ['Meat / Fish Shops', 'Bengaluru'],
        8: ['Sweet Shops/Mithai Shop', 'Bengaluru'],
        9: ['Ice Cream / Dessert Parlors', 'Bengaluru'],
        10: ['Departmental store/Supermarket/Walmart/Dmart', 'Bengaluru'],
        11: ['Bakery', 'Bengaluru', ],
        13: ['Tea/Coffee stall', 'Bengaluru'],
        14: ['Pan/Cigarette/Beedi Shop', 'Bengaluru'],
        16: ['Street food vendors', 'Bengaluru'],
        17: ['Restaurants / Dhabas/Café/Chains', 'Bengaluru'],
        18: ['Juice / Coconut Water Vendors', 'Bengaluru'],
        20: ['LPG/CNG/Gas/Fuel (Diesel/Petrol) Stations', 'Bengaluru'],
        21: ['Car / Bike Workshops/Repair Shop', 'Bengaluru'],
        23: [['Smartphone Retail shop /VI/Airtel/jio Stores','Cyber Cafes / Photocopy Shops','Smartphone Retail shop /VI/Airtel/jio Stores/Cyber Cafes / Photocopy Shops'],'Bengaluru'],
        // 20: ['Cyber Cafes / Photocopy Shops', 'Bengaluru'],
        26: ['Dairy', 'Bengaluru'],
       28: ['Branded Clothing Store', 'Bengaluru'],
        29: ['Men’s and women’s clothing shops', 'Bengaluru'],
        30: ['Tailor shop', 'Bengaluru'],
        32: [['Chemists / Medical Stores/Pathology Labs','Hospitals/Clinics / Doctors','Chemists / Medical Stores/Pathology Labs/Hospitals/Clinics / Doctors'], 'Bengaluru'],
        35: ['Salons / Beauty Parlours/ Beauty and barber shops', 'Bengaluru'],
       37: [['Auto Rickshaws/Bike Taxis/Cab Operators','Porter/Uber/Ola/Rapido','Travel/Railway/Metro/Bus','Auto Rickshaws/Bike Taxis/Cab Operators/ Porter / Uber / Ola / Rapido / Travel / Railway / Metro / Bus'], 'Bengaluru'],
        41: [['Consumer Durables/Home Appliance/Electronic Stores (TV, Mixer, etc.)','Electrical/ Plumbing/Hardware Stores','Electronics Repair Shops/ Mobile Repair/Accessory Shops','Consumer Durables/Home Appliance Stores (TV, Mixer, etc.)/Electrical/ Plumbing/Hardware Stores/Electrical/ Plumbing/Hardware Stores'], 'Bengaluru'],
        44: ['Beer, wine, liquor shop', 'Bengaluru'],
        47: [['Premium Category Including Airport stores, Malls, Jewellery stores, educational institutions, hotel & lodging chains & standalones','Airport stores, Malls,Jewellery stores, educational institutions, hotel & lodging chains & standalones Jewellery stores, educational institutions, hotel & lodging chains & standalones'], 'Bengaluru'],
      };
    
      Object.keys(criteriaMapBengaluru).forEach(rowIndex => {
        const criteria = criteriaMapBengaluru[rowIndex];
        const count = countMatches(criteria);
        const cellH = worksheet.getCell(`T${rowIndex}`);
        cellH.value = count;
        if (rowIndex == 12 || rowIndex == 15 || rowIndex == 19 || rowIndex == 22 || rowIndex == 25 || rowIndex == 31 || rowIndex == 34 ||rowIndex == 36 || rowIndex == 40 ) {
          cellH.font = headerStyle.font
          cellH.fill = headerStyle.fill;
          cellH.alignment = headerStyle.alignment;
        cellH.border = headerStyle.border;
        }
        else{
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      }
      });

       const criteriaMapChennai = {
       4: ['Kirana/Grocery store', 'Chennai'],
        5: ['Fruit / Vegetable Vendors', 'Chennai'],
        6: ['Stationery / General Stores', 'Chennai'],
        7: ['Meat / Fish Shops', 'Chennai'],
        8: ['Sweet Shops/Mithai Shop', 'Chennai'],
        9: ['Ice Cream / Dessert Parlors', 'Chennai'],
        10: ['Departmental store/Supermarket/Walmart/Dmart', 'Chennai'],
        11: ['Bakery', 'Chennai', ],
        13: ['Tea/Coffee stall', 'Chennai'],
        14: ['Pan/Cigarette/Beedi Shop', 'Chennai'],
        16: ['Street food vendors', 'Chennai'],
        17: ['Restaurants / Dhabas/Café/Chains', 'Chennai'],
        18: ['Juice / Coconut Water Vendors', 'Chennai'],
        20: ['LPG/CNG/Gas/Fuel (Diesel/Petrol) Stations', 'Chennai'],
        21: ['Car / Bike Workshops/Repair Shop', 'Chennai'],
        23: [['Smartphone Retail shop /VI/Airtel/jio Stores','Cyber Cafes / Photocopy Shops','Smartphone Retail shop /VI/Airtel/jio Stores/Cyber Cafes / Photocopy Shops'],'Chennai'],
        // 20: ['Cyber Cafes / Photocopy Shops', 'Chennai'],
       26: ['Dairy', 'Chennai'],
       28: ['Branded Clothing Store', 'Chennai'],
        29: ['Men’s and women’s clothing shops', 'Chennai'],
        30: ['Tailor shop', 'Chennai'],
        32: [['Chemists / Medical Stores/Pathology Labs','Hospitals/Clinics / Doctors','Chemists / Medical Stores/Pathology Labs/Hospitals/Clinics / Doctors'], 'Chennai'],
        35: ['Salons / Beauty Parlours/ Beauty and barber shops', 'Chennai'],
       37: [['Auto Rickshaws/Bike Taxis/Cab Operators','Porter/Uber/Ola/Rapido','Travel/Railway/Metro/Bus','Auto Rickshaws/Bike Taxis/Cab Operators/ Porter / Uber / Ola / Rapido / Travel / Railway / Metro / Bus'], 'Chennai'],
        41: [['Consumer Durables/Home Appliance/Electronic Stores (TV, Mixer, etc.)','Electrical/ Plumbing/Hardware Stores','Electronics Repair Shops/ Mobile Repair/Accessory Shops','Consumer Durables/Home Appliance Stores (TV, Mixer, etc.)/Electrical/ Plumbing/Hardware Stores/Electrical/ Plumbing/Hardware Stores'], 'Chennai'],
        44: ['Beer, wine, liquor shop', 'Chennai'],
        47: [['Premium Category Including Airport stores, Malls, Jewellery stores, educational institutions, hotel & lodging chains & standalones','Airport stores, Malls,Jewellery stores, educational institutions, hotel & lodging chains & standalones Jewellery stores, educational institutions, hotel & lodging chains & standalones'], 'Chennai'],
      };
    
      Object.keys(criteriaMapChennai).forEach(rowIndex => {
        const criteria = criteriaMapChennai[rowIndex];
        const count = countMatches(criteria);
        const cellH = worksheet.getCell(`W${rowIndex}`);
        cellH.value = count;
         if (rowIndex == 12 || rowIndex == 15 || rowIndex == 19 || rowIndex == 22 || rowIndex == 25 || rowIndex == 31 || rowIndex == 34 ||rowIndex == 36 || rowIndex == 40 ) {
          cellH.font = headerStyle.font
          cellH.fill = headerStyle.fill;
          cellH.alignment = headerStyle.alignment;
        cellH.border = headerStyle.border;
        }
        else{
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      }
      });


          const criteriaMapHyderabad = {
        4: ['Kirana/Grocery store', 'Hyderabad'],
        5: ['Fruit / Vegetable Vendors', 'Hyderabad'],
        6: ['Stationery / General Stores', 'Hyderabad'],
        7: ['Meat / Fish Shops', 'Hyderabad'],
        8: ['Sweet Shops/Mithai Shop', 'Hyderabad'],
        9: ['Ice Cream / Dessert Parlors', 'Hyderabad'],
        10: ['Departmental store/Supermarket/Walmart/Dmart', 'Hyderabad'],
        11: ['Bakery', 'Hyderabad', ],
        13: ['Tea/Coffee stall', 'Hyderabad'],
        14: ['Pan/Cigarette/Beedi Shop', 'Hyderabad'],
        16: ['Street food vendors', 'Hyderabad'],
        17: ['Restaurants / Dhabas/Café/Chains', 'Hyderabad'],
        18: ['Juice / Coconut Water Vendors', 'Hyderabad'],
        20: ['LPG/CNG/Gas/Fuel (Diesel/Petrol) Stations', 'Hyderabad'],
        21: ['Car / Bike Workshops/Repair Shop', 'Hyderabad'],
        23: [['Smartphone Retail shop /VI/Airtel/jio Stores','Cyber Cafes / Photocopy Shops','Smartphone Retail shop /VI/Airtel/jio Stores/Cyber Cafes / Photocopy Shops'],'Hyderabad'],
        // 20: ['Cyber Cafes / Photocopy Shops', 'Hyderabad'],
        26: ['Dairy', 'Hyderabad'],
       28: ['Branded Clothing Store', 'Hyderabad'],
        29: ['Men’s and women’s clothing shops', 'Hyderabad'],
        30: ['Tailor shop', 'Hyderabad'],
        32: [['Chemists / Medical Stores/Pathology Labs','Hospitals/Clinics / Doctors','Chemists / Medical Stores/Pathology Labs/Hospitals/Clinics / Doctors'], 'Hyderabad'],
        35: ['Salons / Beauty Parlours/ Beauty and barber shops', 'Hyderabad'],
        37: [['Auto Rickshaws/Bike Taxis/Cab Operators','Porter/Uber/Ola/Rapido','Travel/Railway/Metro/Bus','Auto Rickshaws/Bike Taxis/Cab Operators/ Porter / Uber / Ola / Rapido / Travel / Railway / Metro / Bus'], 'Hyderabad'],
        38: ['Porter/Uber/Ola/Rapido', 'Hyderabad'],
        39: ['Travel/Railway/Metro/Bus', 'Hyderabad'],
        41: [['Consumer Durables/Home Appliance/Electronic Stores (TV, Mixer, etc.)','Electrical/ Plumbing/Hardware Stores','Electronics Repair Shops/ Mobile Repair/Accessory Shops','Consumer Durables/Home Appliance Stores (TV, Mixer, etc.)/Electrical/ Plumbing/Hardware Stores/Electrical/ Plumbing/Hardware Stores'], 'Hyderabad'],
        44: ['Beer, wine, liquor shop', 'Hyderabad'],
        47: [['Premium Category Including Airport stores, Malls, Jewellery stores, educational institutions, hotel & lodging chains & standalones','Airport stores, Malls,Jewellery stores, educational institutions, hotel & lodging chains & standalones Jewellery stores, educational institutions, hotel & lodging chains & standalones'], 'Hyderabad'],
       
      };
    
      Object.keys(criteriaMapHyderabad).forEach(rowIndex => {
        const criteria = criteriaMapHyderabad[rowIndex];
        const count = countMatches(criteria);
        const cellH = worksheet.getCell(`Z${rowIndex}`);
        cellH.value = count;
        if (rowIndex == 12 || rowIndex == 15 || rowIndex == 19 || rowIndex == 22 || rowIndex == 25 || rowIndex == 31 || rowIndex == 34 ||rowIndex == 36 || rowIndex == 40 ) {
          cellH.font = headerStyle.font
          cellH.fill = headerStyle.fill;
          cellH.alignment = headerStyle.alignment;
        cellH.border = headerStyle.border;
        }
        else{
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      }
      });

          const criteriaMapGuwahati = {
       4: ['Kirana/Grocery store', 'Guwahati'],
        5: ['Fruit / Vegetable Vendors', 'Guwahati'],
        6: ['Stationery / General Stores', 'Guwahati'],
        7: ['Meat / Fish Shops', 'Guwahati'],
        8: ['Sweet Shops/Mithai Shop', 'Guwahati'],
        9: ['Ice Cream / Dessert Parlors', 'Guwahati'],
        10: ['Departmental store/Supermarket/Walmart/Dmart', 'Guwahati'],
        11: ['Bakery', 'Guwahati', ],
        13: ['Tea/Coffee stall', 'Guwahati'],
        14: ['Pan/Cigarette/Beedi Shop', 'Guwahati'],
        16: ['Street food vendors', 'Guwahati'],
        17: ['Restaurants / Dhabas/Café/Chains', 'Guwahati'],
        18: ['Juice / Coconut Water Vendors', 'Guwahati'],
        20: ['LPG/CNG/Gas/Fuel (Diesel/Petrol) Stations', 'Guwahati'],
        21: ['Car / Bike Workshops/Repair Shop', 'Guwahati'],
        23: [['Smartphone Retail shop /VI/Airtel/jio Stores','Cyber Cafes / Photocopy Shops','Smartphone Retail shop /VI/Airtel/jio Stores/Cyber Cafes / Photocopy Shops'],'Guwahati'],
        // 20: ['Cyber Cafes / Photocopy Shops', 'Guwahati'],
        26: ['Dairy', 'Guwahati'],
        28: ['Branded Clothing Store', 'Guwahati'],
        29: ['Men’s and women’s clothing shops', 'Guwahati'],
        30: ['Tailor shop', 'Guwahati'],
        32: [['Chemists / Medical Stores/Pathology Labs','Hospitals/Clinics / Doctors','Chemists / Medical Stores/Pathology Labs/Hospitals/Clinics / Doctors'], 'Guwahati'],
        35: ['Salons / Beauty Parlours/ Beauty and barber shops', 'Guwahati'],
        37: [['Auto Rickshaws/Bike Taxis/Cab Operators','Porter/Uber/Ola/Rapido','Travel/Railway/Metro/Bus','Auto Rickshaws/Bike Taxis/Cab Operators/ Porter / Uber / Ola / Rapido / Travel / Railway / Metro / Bus'], 'Guwahati'],
        41: [['Consumer Durables/Home Appliance/Electronic Stores (TV, Mixer, etc.)','Electrical/ Plumbing/Hardware Stores','Electronics Repair Shops/ Mobile Repair/Accessory Shops','Consumer Durables/Home Appliance Stores (TV, Mixer, etc.)/Electrical/ Plumbing/Hardware Stores/Electrical/ Plumbing/Hardware Stores'], 'Guwahati'],
        44: ['Beer, wine, liquor shop', 'Guwahati'],
      47: [['Premium Category Including Airport stores, Malls, Jewellery stores, educational institutions, hotel & lodging chains & standalones','Airport stores, Malls,Jewellery stores, educational institutions, hotel & lodging chains & standalones Jewellery stores, educational institutions, hotel & lodging chains & standalones'], 'Guwahati'], 
      };
    
      Object.keys(criteriaMapGuwahati).forEach(rowIndex => {
        const criteria = criteriaMapGuwahati[rowIndex];
        const count = countMatches(criteria);
        const cellH = worksheet.getCell(`AC${rowIndex}`);
        cellH.value = count;
         if (rowIndex == 12 || rowIndex == 15 || rowIndex == 19 || rowIndex == 22 || rowIndex == 25 || rowIndex == 31 || rowIndex == 34 ||rowIndex == 36 || rowIndex == 40 ) {
          cellH.font = headerStyle.font
          cellH.fill = headerStyle.fill;
          cellH.alignment = headerStyle.alignment;
        cellH.border = headerStyle.border;
        }
        else{
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      }
      });


           const criteriaMapKolkata = {
        4: ['Kirana/Grocery store', 'Kolkata'],
        5: ['Fruit / Vegetable Vendors', 'Kolkata'],
        6: ['Stationery / General Stores', 'Kolkata'],
        7: ['Meat / Fish Shops', 'Kolkata'],
        8: ['Sweet Shops/Mithai Shop', 'Kolkata'],
        9: ['Ice Cream / Dessert Parlors', 'Kolkata'],
        10: ['Departmental store/Supermarket/Walmart/Dmart', 'Kolkata'],
        11: ['Bakery', 'Kolkata', ],
        13: ['Tea/Coffee stall', 'Kolkata'],
        14: ['Pan/Cigarette/Beedi Shop', 'Kolkata'],
        16: ['Street food vendors', 'Kolkata'],
        17: ['Restaurants / Dhabas/Café/Chains', 'Kolkata'],
        18: ['Juice / Coconut Water Vendors', 'Kolkata'],
        20: ['LPG/CNG/Gas/Fuel (Diesel/Petrol) Stations', 'Kolkata'],
        21: ['Car / Bike Workshops/Repair Shop', 'Kolkata'],
        23: [['Smartphone Retail shop /VI/Airtel/jio Stores','Cyber Cafes / Photocopy Shops','Smartphone Retail shop /VI/Airtel/jio Stores/Cyber Cafes / Photocopy Shops'],'Kolkata'],
        // 20: ['Cyber Cafes / Photocopy Shops', 'Kolkata'],
       26: ['Dairy', 'Kolkata'],
       28: ['Branded Clothing Store', 'Kolkata'],
        29: ['Men’s and women’s clothing shops', 'Kolkata'],
        30: ['Tailor shop', 'Kolkata'],
        32: [['Chemists / Medical Stores/Pathology Labs','Hospitals/Clinics / Doctors','Chemists / Medical Stores/Pathology Labs/Hospitals/Clinics / Doctors'], 'Kolkata'],
        35: ['Salons / Beauty Parlours/ Beauty and barber shops', 'Kolkata'],
        37: [['Auto Rickshaws/Bike Taxis/Cab Operators','Porter/Uber/Ola/Rapido','Travel/Railway/Metro/Bus','Auto Rickshaws/Bike Taxis/Cab Operators/ Porter / Uber / Ola / Rapido / Travel / Railway / Metro / Bus'], 'Kolkata'],
        41: [['Consumer Durables/Home Appliance/Electronic Stores (TV, Mixer, etc.)','Electrical/ Plumbing/Hardware Stores','Electronics Repair Shops/ Mobile Repair/Accessory Shops','Consumer Durables/Home Appliance Stores (TV, Mixer, etc.)/Electrical/ Plumbing/Hardware Stores/Electrical/ Plumbing/Hardware Stores'], 'Kolkata'],
        44: ['Beer, wine, liquor shop', 'Kolkata'],
        47: [['Premium Category Including Airport stores, Malls, Jewellery stores, educational institutions, hotel & lodging chains & standalones','Airport stores, Malls,Jewellery stores, educational institutions, hotel & lodging chains & standalones Jewellery stores, educational institutions, hotel & lodging chains & standalones'], 'Kolkata'],
       
      };
    
      Object.keys(criteriaMapKolkata).forEach(rowIndex => {
        const criteria = criteriaMapKolkata[rowIndex];
        const count = countMatches(criteria);
        const cellH = worksheet.getCell(`AF${rowIndex}`);
        cellH.value = count;
        if (rowIndex == 12 || rowIndex == 15 || rowIndex == 19 || rowIndex == 22 || rowIndex == 25 || rowIndex == 31 || rowIndex == 34 ||rowIndex == 36 || rowIndex == 40 ) {
          cellH.font = headerStyle.font
          cellH.fill = headerStyle.fill;
          cellH.alignment = headerStyle.alignment;
        cellH.border = headerStyle.border;
        }
        else{
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      }
      });


           const criteriaMapPatna = {
        4: ['Kirana/Grocery store', 'Patna'],
        5: ['Fruit / Vegetable Vendors', 'Patna'],
        6: ['Stationery / General Stores', 'Patna'],
        7: ['Meat / Fish Shops', 'Patna'],
        8: ['Sweet Shops/Mithai Shop', 'Patna'],
        9: ['Ice Cream / Dessert Parlors', 'Patna'],
        10: ['Departmental store/Supermarket/Walmart/Dmart', 'Patna'],
        11: ['Bakery', 'Patna', ],
        13: ['Tea/Coffee stall', 'Patna'],
        14: ['Pan/Cigarette/Beedi Shop', 'Patna'],
        16: ['Street food vendors', 'Patna'],
        17: ['Restaurants / Dhabas/Café/Chains', 'Patna'],
        18: ['Juice / Coconut Water Vendors', 'Patna'],
        20: ['LPG/CNG/Gas/Fuel (Diesel/Petrol) Stations', 'Patna'],
        21: ['Car / Bike Workshops/Repair Shop', 'Patna'],
        23: [['Smartphone Retail shop /VI/Airtel/jio Stores','Cyber Cafes / Photocopy Shops','Smartphone Retail shop /VI/Airtel/jio Stores/Cyber Cafes / Photocopy Shops'],'Patna'],
        // 20: ['Cyber Cafes / Photocopy Shops', 'Patna'],
        26: ['Dairy', 'Patna'],
        28: ['Branded Clothing Store', 'Patna'],
        29: ['Men’s and women’s clothing shops', 'Patna'],
        30: ['Tailor shop', 'Patna'],
        32: [['Chemists / Medical Stores/Pathology Labs','Hospitals/Clinics / Doctors','Chemists / Medical Stores/Pathology Labs/Hospitals/Clinics / Doctors'], 'Patna'],
        35: ['Salons / Beauty Parlours/ Beauty and barber shops', 'Patna'],
        37: [['Auto Rickshaws/Bike Taxis/Cab Operators','Porter/Uber/Ola/Rapido','Travel/Railway/Metro/Bus','Auto Rickshaws/Bike Taxis/Cab Operators/ Porter / Uber / Ola / Rapido / Travel / Railway / Metro / Bus'], 'Patna'],
       41: [['Consumer Durables/Home Appliance/Electronic Stores (TV, Mixer, etc.)','Electrical/ Plumbing/Hardware Stores','Electronics Repair Shops/ Mobile Repair/Accessory Shops','Consumer Durables/Home Appliance Stores (TV, Mixer, etc.)/Electrical/ Plumbing/Hardware Stores/Electrical/ Plumbing/Hardware Stores'], 'Patna'],
        44: ['Beer, wine, liquor shop', 'Patna'],
        47: [['Premium Category Including Airport stores, Malls, Jewellery stores, educational institutions, hotel & lodging chains & standalones','Airport stores, Malls,Jewellery stores, educational institutions, hotel & lodging chains & standalones Jewellery stores, educational institutions, hotel & lodging chains & standalones'], 'Patna'],
       
      };
    
      Object.keys(criteriaMapPatna).forEach(rowIndex => {
        const criteria = criteriaMapPatna[rowIndex];
        const count = countMatches(criteria);
        const cellH = worksheet.getCell(`AI${rowIndex}`);
        cellH.value = count;
         if (rowIndex == 12 || rowIndex == 15 || rowIndex == 19 || rowIndex == 22 || rowIndex == 25 || rowIndex == 31 || rowIndex == 34 ||rowIndex == 36 || rowIndex == 40 ) {
          cellH.font = headerStyle.font
          cellH.fill = headerStyle.fill;
          cellH.alignment = headerStyle.alignment;
        cellH.border = headerStyle.border;
        }
        else{
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      }
      });


           const criteriaMapAhmedabad = {
        4: ['Kirana/Grocery store', 'Ahmedabad'],
        5: ['Fruit / Vegetable Vendors', 'Ahmedabad'],
        6: ['Stationery / General Stores', 'Ahmedabad'],
        7: ['Meat / Fish Shops', 'Ahmedabad'],
        8: ['Sweet Shops/Mithai Shop', 'Ahmedabad'],
        9: ['Ice Cream / Dessert Parlors', 'Ahmedabad'],
        10: ['Departmental store/Supermarket/Walmart/Dmart', 'Ahmedabad'],
        11: ['Bakery', 'Ahmedabad', ],
        13: ['Tea/Coffee stall', 'Ahmedabad'],
        14: ['Pan/Cigarette/Beedi Shop', 'Ahmedabad'],
        16: ['Street food vendors', 'Ahmedabad'],
        17: ['Restaurants / Dhabas/Café/Chains', 'Ahmedabad'],
        18: ['Juice / Coconut Water Vendors', 'Ahmedabad'],
        20: ['LPG/CNG/Gas/Fuel (Diesel/Petrol) Stations', 'Ahmedabad'],
        21: ['Car / Bike Workshops/Repair Shop', 'Ahmedabad'],
        23: [['Smartphone Retail shop /VI/Airtel/jio Stores','Cyber Cafes / Photocopy Shops','Smartphone Retail shop /VI/Airtel/jio Stores/Cyber Cafes / Photocopy Shops'],'Ahmedabad'],
        // 20: ['Cyber Cafes / Photocopy Shops', 'Ahmedabad'],
        26: ['Dairy', 'Ahmedabad'],
        28: ['Branded Clothing Store', 'Ahmedabad'],
        29: ['Men’s and women’s clothing shops', 'Ahmedabad'],
        30: ['Tailor shop', 'Ahmedabad'],
        32: [['Chemists / Medical Stores/Pathology Labs','Hospitals/Clinics / Doctors','Chemists / Medical Stores/Pathology Labs/Hospitals/Clinics / Doctors'], 'Ahmedabad'],
        35: ['Salons / Beauty Parlours/ Beauty and barber shops', 'Ahmedabad'],
        37: [['Auto Rickshaws/Bike Taxis/Cab Operators','Porter/Uber/Ola/Rapido','Travel/Railway/Metro/Bus','Auto Rickshaws/Bike Taxis/Cab Operators/ Porter / Uber / Ola / Rapido / Travel / Railway / Metro / Bus'], 'Ahmedabad'],
        41: [['Consumer Durables/Home Appliance/Electronic Stores (TV, Mixer, etc.)','Electrical/ Plumbing/Hardware Stores','Electronics Repair Shops/ Mobile Repair/Accessory Shops','Consumer Durables/Home Appliance Stores (TV, Mixer, etc.)/Electrical/ Plumbing/Hardware Stores/Electrical/ Plumbing/Hardware Stores'], 'Ahmedabad'],
        44: ['Beer, wine, liquor shop', 'Ahmedabad'],
       47: [['Premium Category Including Airport stores, Malls, Jewellery stores, educational institutions, hotel & lodging chains & standalones','Airport stores, Malls,Jewellery stores, educational institutions, hotel & lodging chains & standalones Jewellery stores, educational institutions, hotel & lodging chains & standalones'], 'Ahmedabad'],
      };
    
      Object.keys(criteriaMapAhmedabad).forEach(rowIndex => {
        const criteria = criteriaMapAhmedabad[rowIndex];
        const count = countMatches(criteria);
        const cellH = worksheet.getCell(`AL${rowIndex}`);
        cellH.value = count;
        if (rowIndex == 12 || rowIndex == 15 || rowIndex == 19 || rowIndex == 22 || rowIndex == 25 || rowIndex == 31 || rowIndex == 34 ||rowIndex == 36 || rowIndex == 40 ) {
          cellH.font = headerStyle.font
          cellH.fill = headerStyle.fill;
          cellH.alignment = headerStyle.alignment;
        cellH.border = headerStyle.border;
        }
        else{
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      }
      });

           const criteriaMapSurat = {
       4: ['Kirana/Grocery store', 'Surat'],
        5: ['Fruit / Vegetable Vendors', 'Surat'],
        6: ['Stationery / General Stores', 'Surat'],
        7: ['Meat / Fish Shops', 'Surat'],
        8: ['Sweet Shops/Mithai Shop', 'Surat'],
        9: ['Ice Cream / Dessert Parlors', 'Surat'],
        10: ['Departmental store/Supermarket/Walmart/Dmart', 'Surat'],
        11: ['Bakery', 'Surat', ],
        13: ['Tea/Coffee stall', 'Surat'],
        14: ['Pan/Cigarette/Beedi Shop', 'Surat'],
        16: ['Street food vendors', 'Surat'],
        17: ['Restaurants / Dhabas/Café/Chains', 'Surat'],
        18: ['Juice / Coconut Water Vendors', 'Surat'],
        20: ['LPG/CNG/Gas/Fuel (Diesel/Petrol) Stations', 'Surat'],
        21: ['Car / Bike Workshops/Repair Shop', 'Surat'],
        23: [['Smartphone Retail shop /VI/Airtel/jio Stores','Cyber Cafes / Photocopy Shops','Smartphone Retail shop /VI/Airtel/jio Stores/Cyber Cafes / Photocopy Shops'],'Surat'],
        // 20: ['Cyber Cafes / Photocopy Shops', 'Surat'],
        26: ['Dairy', 'Surat'],
        28: ['Branded Clothing Store', 'Surat'],
        29: ['Men’s and women’s clothing shops', 'Surat'],
        30: ['Tailor shop', 'Surat'],
        32: [['Chemists / Medical Stores/Pathology Labs','Hospitals/Clinics / Doctors','Chemists / Medical Stores/Pathology Labs/Hospitals/Clinics / Doctors'], 'Surat'],
        35: ['Salons / Beauty Parlours/ Beauty and barber shops', 'Surat'],
       37: [['Auto Rickshaws/Bike Taxis/Cab Operators','Porter/Uber/Ola/Rapido','Travel/Railway/Metro/Bus','Auto Rickshaws/Bike Taxis/Cab Operators/ Porter / Uber / Ola / Rapido / Travel / Railway / Metro / Bus'], 'Surat'],
        41: [['Consumer Durables/Home Appliance/Electronic Stores (TV, Mixer, etc.)','Electrical/ Plumbing/Hardware Stores','Electronics Repair Shops/ Mobile Repair/Accessory Shops','Consumer Durables/Home Appliance Stores (TV, Mixer, etc.)/Electrical/ Plumbing/Hardware Stores/Electrical/ Plumbing/Hardware Stores'], 'Surat'],
        44: ['Beer, wine, liquor shop', 'Surat'],
       47: [['Premium Category Including Airport stores, Malls, Jewellery stores, educational institutions, hotel & lodging chains & standalones','Airport stores, Malls,Jewellery stores, educational institutions, hotel & lodging chains & standalones Jewellery stores, educational institutions, hotel & lodging chains & standalones'], 'Surat'],
      };
    
      Object.keys(criteriaMapSurat).forEach(rowIndex => {
        const criteria = criteriaMapSurat[rowIndex];
        const count = countMatches(criteria);
        const cellH = worksheet.getCell(`AO${rowIndex}`);
        cellH.value = count;
         if (rowIndex == 12 || rowIndex == 15 || rowIndex == 19 || rowIndex == 22 || rowIndex == 25 || rowIndex == 31 || rowIndex == 34 ||rowIndex == 36 || rowIndex == 40 ) {
          cellH.font = headerStyle.font
          cellH.fill = headerStyle.fill;
          cellH.alignment = headerStyle.alignment;
        cellH.border = headerStyle.border;
        }
        else{
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      }
      });


           const criteriaMapIndore = {
        4: ['Kirana/Grocery store', 'Indore'],
        5: ['Fruit / Vegetable Vendors', 'Indore'],
        6: ['Stationery / General Stores', 'Indore'],
        7: ['Meat / Fish Shops', 'Indore'],
        8: ['Sweet Shops/Mithai Shop', 'Indore'],
        9: ['Ice Cream / Dessert Parlors', 'Indore'],
        10: ['Departmental store/Supermarket/Walmart/Dmart', 'Indore'],
        11: ['Bakery', 'Indore', ],
        13: ['Tea/Coffee stall', 'Indore'],
        14: ['Pan/Cigarette/Beedi Shop', 'Indore'],
        16: ['Street food vendors', 'Indore'],
        17: ['Restaurants / Dhabas/Café/Chains', 'Indore'],
        18: ['Juice / Coconut Water Vendors', 'Indore'],
        20: ['LPG/CNG/Gas/Fuel (Diesel/Petrol) Stations', 'Indore'],
        21: ['Car / Bike Workshops/Repair Shop', 'Indore'],
        23: [['Smartphone Retail shop /VI/Airtel/jio Stores','Cyber Cafes / Photocopy Shops','Smartphone Retail shop /VI/Airtel/jio Stores/Cyber Cafes / Photocopy Shops'],'Indore'],
        // 20: ['Cyber Cafes / Photocopy Shops', 'Indore'],
        26: ['Dairy', 'Indore'],
        28: ['Branded Clothing Store', 'Indore'],
        29: ['Men’s and women’s clothing shops', 'Indore'],
        30: ['Tailor shop', 'Indore'],
        32: [['Chemists / Medical Stores/Pathology Labs','Hospitals/Clinics / Doctors','Chemists / Medical Stores/Pathology Labs/Hospitals/Clinics / Doctors'], 'Indore'],
        35: ['Salons / Beauty Parlours/ Beauty and barber shops', 'Indore'],
        37: [['Auto Rickshaws/Bike Taxis/Cab Operators','Porter/Uber/Ola/Rapido','Travel/Railway/Metro/Bus','Auto Rickshaws/Bike Taxis/Cab Operators/ Porter / Uber / Ola / Rapido / Travel / Railway / Metro / Bus'], 'Indore'],
        41: [['Consumer Durables/Home Appliance/Electronic Stores (TV, Mixer, etc.)','Electrical/ Plumbing/Hardware Stores','Electronics Repair Shops/ Mobile Repair/Accessory Shops','Consumer Durables/Home Appliance Stores (TV, Mixer, etc.)/Electrical/ Plumbing/Hardware Stores/Electrical/ Plumbing/Hardware Stores'], 'Indore'],
        44: ['Beer, wine, liquor shop', 'Indore'],
        47: [['Premium Category Including Airport stores, Malls, Jewellery stores, educational institutions, hotel & lodging chains & standalones','Airport stores, Malls,Jewellery stores, educational institutions, hotel & lodging chains & standalones Jewellery stores, educational institutions, hotel & lodging chains & standalones'], 'Indore'],
      };
    
      Object.keys(criteriaMapIndore).forEach(rowIndex => {
        const criteria = criteriaMapIndore[rowIndex];
        const count = countMatches(criteria);
        const cellH = worksheet.getCell(`AR${rowIndex}`);
        cellH.value = count;
         if (rowIndex == 12 || rowIndex == 15 || rowIndex == 19 || rowIndex == 22 || rowIndex == 25 || rowIndex == 31 || rowIndex == 34 ||rowIndex == 36 || rowIndex == 40 ) {
          cellH.font = headerStyle.font
          cellH.fill = headerStyle.fill;
          cellH.alignment = headerStyle.alignment;
        cellH.border = headerStyle.border;
        }
        else{
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      }
      });

           const criteriaMapMumbai = {
        4: ['Kirana/Grocery store', 'Mumbai'],
        5: ['Fruit / Vegetable Vendors', 'Mumbai'],
        6: ['Stationery / General Stores', 'Mumbai'],
        7: ['Meat / Fish Shops', 'Mumbai'],
        8: ['Sweet Shops/Mithai Shop', 'Mumbai'],
        9: ['Ice Cream / Dessert Parlors', 'Mumbai'],
        10: ['Departmental store/Supermarket/Walmart/Dmart', 'Mumbai'],
        11: ['Bakery', 'Mumbai', ],
        13: ['Tea/Coffee stall', 'Mumbai'],
        14: ['Pan/Cigarette/Beedi Shop', 'Mumbai'],
        16: ['Street food vendors', 'Mumbai'],
        17: ['Restaurants / Dhabas/Café/Chains', 'Mumbai'],
        18: ['Juice / Coconut Water Vendors', 'Mumbai'],
        20: ['LPG/CNG/Gas/Fuel (Diesel/Petrol) Stations', 'Mumbai'],
        21: ['Car / Bike Workshops/Repair Shop', 'Mumbai'],
        23: [['Smartphone Retail shop /VI/Airtel/jio Stores','Cyber Cafes / Photocopy Shops','Smartphone Retail shop /VI/Airtel/jio Stores/Cyber Cafes / Photocopy Shops'],'Mumbai'],
        // 20: ['Cyber Cafes / Photocopy Shops', 'Mumbai'],
        26: ['Dairy', 'Mumbai'],
        28: ['Branded Clothing Store', 'Mumbai'],
        29: ['Men’s and women’s clothing shops', 'Mumbai'],
        30: ['Tailor shop', 'Mumbai'],
        32: [['Chemists / Medical Stores/Pathology Labs','Hospitals/Clinics / Doctors','Chemists / Medical Stores/Pathology Labs/Hospitals/Clinics / Doctors'], 'Mumbai'],
        35: ['Salons / Beauty Parlours/ Beauty and barber shops', 'Mumbai'],
        37: [['Auto Rickshaws/Bike Taxis/Cab Operators','Porter/Uber/Ola/Rapido','Travel/Railway/Metro/Bus','Auto Rickshaws/Bike Taxis/Cab Operators/ Porter / Uber / Ola / Rapido / Travel / Railway / Metro / Bus'], 'Mumbai'],
        41: [['Consumer Durables/Home Appliance/Electronic Stores (TV, Mixer, etc.)','Electrical/ Plumbing/Hardware Stores','Electronics Repair Shops/ Mobile Repair/Accessory Shops','Consumer Durables/Home Appliance Stores (TV, Mixer, etc.)/Electrical/ Plumbing/Hardware Stores/Electrical/ Plumbing/Hardware Stores'], 'Mumbai'],
        44: ['Beer, wine, liquor shop', 'Mumbai'],
       47: [['Premium Category Including Airport stores, Malls, Jewellery stores, educational institutions, hotel & lodging chains & standalones','Airport stores, Malls,Jewellery stores, educational institutions, hotel & lodging chains & standalones Jewellery stores, educational institutions, hotel & lodging chains & standalones'], 'Mumbai'],
       
      };
    
      Object.keys(criteriaMapMumbai).forEach(rowIndex => {
        const criteria = criteriaMapMumbai[rowIndex];
        const count = countMatches(criteria);
        const cellH = worksheet.getCell(`AU${rowIndex}`);
        cellH.value = count;
        if (rowIndex == 12 || rowIndex == 15 || rowIndex == 19 || rowIndex == 22 || rowIndex == 25 || rowIndex == 31 || rowIndex == 34 ||rowIndex == 36 || rowIndex == 40 ) {
          cellH.font = headerStyle.font
          cellH.fill = headerStyle.fill;
          cellH.alignment = headerStyle.alignment;
        cellH.border = headerStyle.border;
        }
        else{
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      }
      });


          const criteriaMapPune = {
       4: ['Kirana/Grocery store', 'Pune'],
        5: ['Fruit / Vegetable Vendors', 'Pune'],
        6: ['Stationery / General Stores', 'Pune'],
        7: ['Meat / Fish Shops', 'Pune'],
        8: ['Sweet Shops/Mithai Shop', 'Pune'],
        9: ['Ice Cream / Dessert Parlors', 'Pune'],
        10: ['Departmental store/Supermarket/Walmart/Dmart', 'Pune'],
        11: ['Bakery', 'Pune', ],
        13: ['Tea/Coffee stall', 'Pune'],
        14: ['Pan/Cigarette/Beedi Shop', 'Pune'],
        16: ['Street food vendors', 'Pune'],
        17: ['Restaurants / Dhabas/Café/Chains', 'Pune'],
        18: ['Juice / Coconut Water Vendors', 'Pune'],
        20: ['LPG/CNG/Gas/Fuel (Diesel/Petrol) Stations', 'Pune'],
        21: ['Car / Bike Workshops/Repair Shop', 'Pune'],
        23: [['Smartphone Retail shop /VI/Airtel/jio Stores','Cyber Cafes / Photocopy Shops','Smartphone Retail shop /VI/Airtel/jio Stores/Cyber Cafes / Photocopy Shops'],'Pune'],
        // 20: ['Cyber Cafes / Photocopy Shops', 'Pune'],
        26: ['Dairy', 'Pune'],
        28: ['Branded Clothing Store', 'Pune'],
        29: ['Men’s and women’s clothing shops', 'Pune'],
        30: ['Tailor shop', 'Pune'],
        32: [['Chemists / Medical Stores/Pathology Labs','Hospitals/Clinics / Doctors','Chemists / Medical Stores/Pathology Labs/Hospitals/Clinics / Doctors'], 'Pune'],
        35: ['Salons / Beauty Parlours/ Beauty and barber shops', 'Pune'],
        37: [['Auto Rickshaws/Bike Taxis/Cab Operators','Porter/Uber/Ola/Rapido','Travel/Railway/Metro/Bus','Auto Rickshaws/Bike Taxis/Cab Operators/ Porter / Uber / Ola / Rapido / Travel / Railway / Metro / Bus'], 'Pune'],
        41: [['Consumer Durables/Home Appliance/Electronic Stores (TV, Mixer, etc.)','Electrical/ Plumbing/Hardware Stores','Electronics Repair Shops/ Mobile Repair/Accessory Shops','Consumer Durables/Home Appliance Stores (TV, Mixer, etc.)/Electrical/ Plumbing/Hardware Stores/Electrical/ Plumbing/Hardware Stores'], 'Pune'],
        44: ['Beer, wine, liquor shop', 'Pune'],
       47: [['Premium Category Including Airport stores, Malls, Jewellery stores, educational institutions, hotel & lodging chains & standalones','Airport stores, Malls,Jewellery stores, educational institutions, hotel & lodging chains & standalones Jewellery stores, educational institutions, hotel & lodging chains & standalones'], 'Pune'],
      };
    
      Object.keys(criteriaMapPune).forEach(rowIndex => {
        const criteria = criteriaMapPune[rowIndex];
        const count = countMatches(criteria);
        const cellH = worksheet.getCell(`AX${rowIndex}`);
        cellH.value = count;
        if (rowIndex == 4 || rowIndex == 39) {
          cellH.font = headerStyle.font
          cellH.fill = cellStyle.fill;
          cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
        }
        else{
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      }
      });

           const criteriaMapJabalpur = {
         4: ['Kirana/Grocery store', 'Jabalpur'],
        5: ['Fruit / Vegetable Vendors', 'Jabalpur'],
        6: ['Stationery / General Stores', 'Jabalpur'],
        7: ['Meat / Fish Shops', 'Jabalpur'],
        8: ['Sweet Shops/Mithai Shop', 'Jabalpur'],
        9: ['Ice Cream / Dessert Parlors', 'Jabalpur'],
        10: ['Departmental store/Supermarket/Walmart/Dmart', 'Jabalpur'],
        11: ['Bakery', 'Jabalpur', ],
        13: ['Tea/Coffee stall', 'Jabalpur'],
        14: ['Pan/Cigarette/Beedi Shop', 'Jabalpur'],
        16: ['Street food vendors', 'Jabalpur'],
        17: ['Restaurants / Dhabas/Café/Chains', 'Jabalpur'],
        18: ['Juice / Coconut Water Vendors', 'Jabalpur'],
        20: ['LPG/CNG/Gas/Fuel (Diesel/Petrol) Stations', 'Jabalpur'],
        21: ['Car / Bike Workshops/Repair Shop', 'Jabalpur'],
        23: [['Smartphone Retail shop /VI/Airtel/jio Stores','Cyber Cafes / Photocopy Shops','Smartphone Retail shop /VI/Airtel/jio Stores/Cyber Cafes / Photocopy Shops'],'Jabalpur'],
        // 20: ['Cyber Cafes / Photocopy Shops', 'Jabalpur'],
       26: ['Dairy', 'Jabalpur'],
        28: ['Branded Clothing Store', 'Jabalpur'],
        29: ['Men’s and women’s clothing shops', 'Jabalpur'],
        30: ['Tailor shop', 'Jabalpur'],
        32: [['Chemists / Medical Stores/Pathology Labs','Hospitals/Clinics / Doctors','Chemists / Medical Stores/Pathology Labs/Hospitals/Clinics / Doctors'], 'Jabalpur'],
        35: ['Salons / Beauty Parlours/ Beauty and barber shops', 'Jabalpur'],
        37: [['Auto Rickshaws/Bike Taxis/Cab Operators','Porter/Uber/Ola/Rapido','Travel/Railway/Metro/Bus','Auto Rickshaws/Bike Taxis/Cab Operators/ Porter / Uber / Ola / Rapido / Travel / Railway / Metro / Bus'], 'Jabalpur'],
        41: [['Consumer Durables/Home Appliance/Electronic Stores (TV, Mixer, etc.)','Electrical/ Plumbing/Hardware Stores','Electronics Repair Shops/ Mobile Repair/Accessory Shops','Consumer Durables/Home Appliance Stores (TV, Mixer, etc.)/Electrical/ Plumbing/Hardware Stores/Electrical/ Plumbing/Hardware Stores'], 'Jabalpur'],
        44: ['Beer, wine, liquor shop', 'Jabalpur'],
       47: [['Premium Category Including Airport stores, Malls, Jewellery stores, educational institutions, hotel & lodging chains & standalones','Airport stores, Malls,Jewellery stores, educational institutions, hotel & lodging chains & standalones Jewellery stores, educational institutions, hotel & lodging chains & standalones'], 'Jabalpur'],
       
      };
    
      Object.keys(criteriaMapJabalpur).forEach(rowIndex => {
        const criteria = criteriaMapJabalpur[rowIndex];
        const count = countMatches(criteria);
        const cellH = worksheet.getCell(`BA${rowIndex}`);
        cellH.value = count;
        if (rowIndex == 12 || rowIndex == 15 || rowIndex == 19 || rowIndex == 22 || rowIndex == 25 || rowIndex == 31 || rowIndex == 34 ||rowIndex == 36 || rowIndex == 40 ) {
          cellH.font = headerStyle.font
          cellH.fill = headerStyle.fill;
          cellH.alignment = headerStyle.alignment;
        cellH.border = headerStyle.border;
        }
        else{
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      }
      });

           const criteriaMapDharamshala = {
       4: ['Kirana/Grocery store', 'Dharamshala'],
        5: ['Fruit / Vegetable Vendors', 'Dharamshala'],
        6: ['Stationery / General Stores', 'Dharamshala'],
        7: ['Meat / Fish Shops', 'Dharamshala'],
        8: ['Sweet Shops/Mithai Shop', 'Dharamshala'],
        9: ['Ice Cream / Dessert Parlors', 'Dharamshala'],
        10: ['Departmental store/Supermarket/Walmart/Dmart', 'Dharamshala'],
        11: ['Bakery', 'Dharamshala', ],
        13: ['Tea/Coffee stall', 'Dharamshala'],
        14: ['Pan/Cigarette/Beedi Shop', 'Dharamshala'],
        16: ['Street food vendors', 'Dharamshala'],
        17: ['Restaurants / Dhabas/Café/Chains', 'Dharamshala'],
        18: ['Juice / Coconut Water Vendors', 'Dharamshala'],
        20: ['LPG/CNG/Gas/Fuel (Diesel/Petrol) Stations', 'Dharamshala'],
        21: ['Car / Bike Workshops/Repair Shop', 'Dharamshala'],
        23: [['Smartphone Retail shop /VI/Airtel/jio Stores','Cyber Cafes / Photocopy Shops','Smartphone Retail shop /VI/Airtel/jio Stores/Cyber Cafes / Photocopy Shops'],'Dharamshala'],
        // 20: ['Cyber Cafes / Photocopy Shops', 'Dharamshala'],
        26: ['Dairy', 'Dharamshala'],
       28: ['Branded Clothing Store', 'Dharamshala'],
        29: ['Men’s and women’s clothing shops', 'Dharamshala'],
        30: ['Tailor shop', 'Dharamshala'],
        32: [['Chemists / Medical Stores/Pathology Labs','Hospitals/Clinics / Doctors','Chemists / Medical Stores/Pathology Labs/Hospitals/Clinics / Doctors'], 'Dharamshala'],
        35: ['Salons / Beauty Parlours/ Beauty and barber shops', 'Dharamshala'],
        37: [['Auto Rickshaws/Bike Taxis/Cab Operators','Porter/Uber/Ola/Rapido','Travel/Railway/Metro/Bus','Auto Rickshaws/Bike Taxis/Cab Operators/ Porter / Uber / Ola / Rapido / Travel / Railway / Metro / Bus'], 'Dharamshala'],
        41: [['Consumer Durables/Home Appliance/Electronic Stores (TV, Mixer, etc.)','Electrical/ Plumbing/Hardware Stores','Electronics Repair Shops/ Mobile Repair/Accessory Shops','Consumer Durables/Home Appliance Stores (TV, Mixer, etc.)/Electrical/ Plumbing/Hardware Stores/Electrical/ Plumbing/Hardware Stores'], 'Dharamshala'],
        44: ['Beer, wine, liquor shop', 'Dharamshala'],
        47: [['Premium Category Including Airport stores, Malls, Jewellery stores, educational institutions, hotel & lodging chains & standalones','Airport stores, Malls,Jewellery stores, educational institutions, hotel & lodging chains & standalones Jewellery stores, educational institutions, hotel & lodging chains & standalones'], 'Dharamshala'],
      };
    
      Object.keys(criteriaMapDharamshala).forEach(rowIndex => {
        const criteria = criteriaMapDharamshala[rowIndex];
        const count = countMatches(criteria);
        const cellH = worksheet.getCell(`BD${rowIndex}`);
        cellH.value = count;
        if (rowIndex == 12 || rowIndex == 15 || rowIndex == 19 || rowIndex == 22 || rowIndex == 25 || rowIndex == 31 || rowIndex == 34 ||rowIndex == 36 || rowIndex == 40 ) {
          cellH.font = headerStyle.font
          cellH.fill = headerStyle.fill;
          cellH.alignment = headerStyle.alignment;
        cellH.border = headerStyle.border;
        }
        else{
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      }
      });

           const criteriaMapLudhiana = {
         4: ['Kirana/Grocery store', 'Ludhiana'],
        5: ['Fruit / Vegetable Vendors', 'Ludhiana'],
        6: ['Stationery / General Stores', 'Ludhiana'],
        7: ['Meat / Fish Shops', 'Ludhiana'],
        8: ['Sweet Shops/Mithai Shop', 'Ludhiana'],
        9: ['Ice Cream / Dessert Parlors', 'Ludhiana'],
        10: ['Departmental store/Supermarket/Walmart/Dmart', 'Ludhiana'],
        11: ['Bakery', 'Ludhiana', ],
        13: ['Tea/Coffee stall', 'Ludhiana'],
        14: ['Pan/Cigarette/Beedi Shop', 'Ludhiana'],
        16: ['Street food vendors', 'Ludhiana'],
        17: ['Restaurants / Dhabas/Café/Chains', 'Ludhiana'],
        18: ['Juice / Coconut Water Vendors', 'Ludhiana'],
        20: ['LPG/CNG/Gas/Fuel (Diesel/Petrol) Stations', 'Ludhiana'],
        21: ['Car / Bike Workshops/Repair Shop', 'Ludhiana'],
        23: [['Smartphone Retail shop /VI/Airtel/jio Stores','Cyber Cafes / Photocopy Shops','Smartphone Retail shop /VI/Airtel/jio Stores/Cyber Cafes / Photocopy Shops'],'Ludhiana'],
        // 20: ['Cyber Cafes / Photocopy Shops', 'Ludhiana'],
       26: ['Dairy', 'Ludhiana'],
       28: ['Branded Clothing Store', 'Ludhiana'],
        29: ['Men’s and women’s clothing shops', 'Ludhiana'],
        30: ['Tailor shop', 'Ludhiana'],
        32: [['Chemists / Medical Stores/Pathology Labs','Hospitals/Clinics / Doctors','Chemists / Medical Stores/Pathology Labs/Hospitals/Clinics / Doctors'], 'Ludhiana'],
        35: ['Salons / Beauty Parlours/ Beauty and barber shops', 'Ludhiana'],
        37: [['Auto Rickshaws/Bike Taxis/Cab Operators','Porter/Uber/Ola/Rapido','Travel/Railway/Metro/Bus','Auto Rickshaws/Bike Taxis/Cab Operators/ Porter / Uber / Ola / Rapido / Travel / Railway / Metro / Bus'], 'Ludhiana'],
        41: [['Consumer Durables/Home Appliance/Electronic Stores (TV, Mixer, etc.)','Electrical/ Plumbing/Hardware Stores','Electronics Repair Shops/ Mobile Repair/Accessory Shops','Consumer Durables/Home Appliance Stores (TV, Mixer, etc.)/Electrical/ Plumbing/Hardware Stores/Electrical/ Plumbing/Hardware Stores'], 'Ludhiana'],
        44: ['Beer, wine, liquor shop', 'Ludhiana'],
       47: [['Premium Category Including Airport stores, Malls, Jewellery stores, educational institutions, hotel & lodging chains & standalones','Airport stores, Malls,Jewellery stores, educational institutions, hotel & lodging chains & standalones Jewellery stores, educational institutions, hotel & lodging chains & standalones'], 'Ludhianan'],
       
      };
    
      Object.keys(criteriaMapLudhiana).forEach(rowIndex => {
        const criteria = criteriaMapLudhiana[rowIndex];
        const count = countMatches(criteria);
        const cellH = worksheet.getCell(`BG${rowIndex}`);
        cellH.value = count;
         if (rowIndex == 12 || rowIndex == 15 || rowIndex == 19 || rowIndex == 22 || rowIndex == 25 || rowIndex == 31 || rowIndex == 34 ||rowIndex == 36 || rowIndex == 40 ) {
          cellH.font = headerStyle.font
          cellH.fill = headerStyle.fill;
          cellH.alignment = headerStyle.alignment;
        cellH.border = headerStyle.border;
        }
        else{
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      }
      });

           const criteriaMapRohtak = {
        4: ['Kirana/Grocery store', 'Rohtak'],
        5: ['Fruit / Vegetable Vendors', 'Rohtak'],
        6: ['Stationery / General Stores', 'Rohtak'],
        7: ['Meat / Fish Shops', 'Rohtak'],
        8: ['Sweet Shops/Mithai Shop', 'Rohtak'],
        9: ['Ice Cream / Dessert Parlors', 'Rohtak'],
        10: ['Departmental store/Supermarket/Walmart/Dmart', 'Rohtak'],
        11: ['Bakery', 'Rohtak', ],
        13: ['Tea/Coffee stall', 'Rohtak'],
        14: ['Pan/Cigarette/Beedi Shop', 'Rohtak'],
        16: ['Street food vendors', 'Rohtak'],
        17: ['Restaurants / Dhabas/Café/Chains', 'Rohtak'],
        18: ['Juice / Coconut Water Vendors', 'Rohtak'],
        20: ['LPG/CNG/Gas/Fuel (Diesel/Petrol) Stations', 'Rohtak'],
        21: ['Car / Bike Workshops/Repair Shop', 'Rohtak'],
        23: [['Smartphone Retail shop /VI/Airtel/jio Stores','Cyber Cafes / Photocopy Shops','Smartphone Retail shop /VI/Airtel/jio Stores/Cyber Cafes / Photocopy Shops'],'Rohtak'],
        // 20: ['Cyber Cafes / Photocopy Shops', 'Rohtak'],
       26: ['Dairy', 'Rohtak'],
       28: ['Branded Clothing Store', 'Rohtak'],
        29: ['Men’s and women’s clothing shops', 'Rohtak'],
        30: ['Tailor shop', 'Rohtak'],
        32: [['Chemists / Medical Stores/Pathology Labs','Hospitals/Clinics / Doctors','Chemists / Medical Stores/Pathology Labs/Hospitals/Clinics / Doctors'], 'Rohtak'],
        35: ['Salons / Beauty Parlours/ Beauty and barber shops', 'Rohtak'],
       37: [['Auto Rickshaws/Bike Taxis/Cab Operators','Porter/Uber/Ola/Rapido','Travel/Railway/Metro/Bus','Auto Rickshaws/Bike Taxis/Cab Operators/ Porter / Uber / Ola / Rapido / Travel / Railway / Metro / Bus'], 'Rohtak'],
        41: [['Consumer Durables/Home Appliance/Electronic Stores (TV, Mixer, etc.)','Electrical/ Plumbing/Hardware Stores','Electronics Repair Shops/ Mobile Repair/Accessory Shops','Consumer Durables/Home Appliance Stores (TV, Mixer, etc.)/Electrical/ Plumbing/Hardware Stores/Electrical/ Plumbing/Hardware Stores'], 'Rohtak'],
        44: ['Beer, wine, liquor shop', 'Rohtak'],
        47: [['Premium Category Including Airport stores, Malls, Jewellery stores, educational institutions, hotel & lodging chains & standalones','Airport stores, Malls,Jewellery stores, educational institutions, hotel & lodging chains & standalones Jewellery stores, educational institutions, hotel & lodging chains & standalones'], 'Rohtak'],
       
      };
    
      Object.keys(criteriaMapRohtak).forEach(rowIndex => {
        const criteria = criteriaMapRohtak[rowIndex];
        const count = countMatches(criteria);
        const cellH = worksheet.getCell(`BJ${rowIndex}`);
        cellH.value = count;
        if (rowIndex == 12 || rowIndex == 15 || rowIndex == 19 || rowIndex == 22 || rowIndex == 25 || rowIndex == 31 || rowIndex == 34 ||rowIndex == 36 || rowIndex == 40 ) {
          cellH.font = headerStyle.font
          cellH.fill = headerStyle.fill;
          cellH.alignment = headerStyle.alignment;
        cellH.border = headerStyle.border;
        }
        else{
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      }
      });

           const criteriaMapCochin = {
        4: ['Kirana/Grocery store', 'Cochin'],
        5: ['Fruit / Vegetable Vendors', 'Cochin'],
        6: ['Stationery / General Stores', 'Cochin'],
        7: ['Meat / Fish Shops', 'Cochin'],
        8: ['Sweet Shops/Mithai Shop', 'Cochin'],
        9: ['Ice Cream / Dessert Parlors', 'Cochin'],
        10: ['Departmental store/Supermarket/Walmart/Dmart', 'Cochin'],
        11: ['Bakery', 'Cochin', ],
        13: ['Tea/Coffee stall', 'Cochin'],
        14: ['Pan/Cigarette/Beedi Shop', 'Cochin'],
        16: ['Street food vendors', 'Cochin'],
        17: ['Restaurants / Dhabas/Café/Chains', 'Cochin'],
        18: ['Juice / Coconut Water Vendors', 'Cochin'],
        20: ['LPG/CNG/Gas/Fuel (Diesel/Petrol) Stations', 'Cochin'],
        21: ['Car / Bike Workshops/Repair Shop', 'Cochin'],
        23: [['Smartphone Retail shop /VI/Airtel/jio Stores','Cyber Cafes / Photocopy Shops','Smartphone Retail shop /VI/Airtel/jio Stores/Cyber Cafes / Photocopy Shops'],'Cochin'],
        // 20: ['Cyber Cafes / Photocopy Shops', 'Cochin'],
        26: ['Dairy', 'Cochin'],
        28: ['Branded Clothing Store', 'Cochin'],
        29: ['Men’s and women’s clothing shops', 'Cochin'],
        30: ['Tailor shop', 'Cochin'],
        32: [['Chemists / Medical Stores/Pathology Labs','Hospitals/Clinics / Doctors','Chemists / Medical Stores/Pathology Labs/Hospitals/Clinics / Doctors'], 'Cochin'],
        35: ['Salons / Beauty Parlours/ Beauty and barber shops', 'Cochin'],
       37: [['Auto Rickshaws/Bike Taxis/Cab Operators','Porter/Uber/Ola/Rapido','Travel/Railway/Metro/Bus','Auto Rickshaws/Bike Taxis/Cab Operators/ Porter / Uber / Ola / Rapido / Travel / Railway / Metro / Bus'], 'Cochin'],
        41: [['Consumer Durables/Home Appliance/Electronic Stores (TV, Mixer, etc.)','Electrical/ Plumbing/Hardware Stores','Electronics Repair Shops/ Mobile Repair/Accessory Shops','Consumer Durables/Home Appliance Stores (TV, Mixer, etc.)/Electrical/ Plumbing/Hardware Stores/Electrical/ Plumbing/Hardware Stores'], 'Cochin'],
        44: ['Beer, wine, liquor shop', 'Cochin'],
        47: [['Premium Category Including Airport stores, Malls, Jewellery stores, educational institutions, hotel & lodging chains & standalones','Airport stores, Malls,Jewellery stores, educational institutions, hotel & lodging chains & standalones Jewellery stores, educational institutions, hotel & lodging chains & standalones'], 'Cochin'],
       
      };
    
      Object.keys(criteriaMapCochin).forEach(rowIndex => {
        const criteria = criteriaMapCochin[rowIndex];
        const count = countMatches(criteria);
        const cellH = worksheet.getCell(`BM${rowIndex}`);
        cellH.value = count;
         if (rowIndex == 12 || rowIndex == 15 || rowIndex == 19 || rowIndex == 22 || rowIndex == 25 || rowIndex == 31 || rowIndex == 34 ||rowIndex == 36 || rowIndex == 40 ) {
          cellH.font = headerStyle.font
          cellH.fill = headerStyle.fill;
          cellH.alignment = headerStyle.alignment;
        cellH.border = headerStyle.border;
        }
        else{
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      }
      });

           const criteriaMapMysuru = {
      4: ['Kirana/Grocery store', 'Mysuru'],
        5: ['Fruit / Vegetable Vendors', 'Mysuru'],
        6: ['Stationery / General Stores', 'Mysuru'],
        7: ['Meat / Fish Shops', 'Mysuru'],
        8: ['Sweet Shops/Mithai Shop', 'Mysuru'],
        9: ['Ice Cream / Dessert Parlors', 'Mysuru'],
        10: ['Departmental store/Supermarket/Walmart/Dmart', 'Mysuru'],
        11: ['Bakery', 'Mysuru', ],
        13: ['Tea/Coffee stall', 'Mysuru'],
        14: ['Pan/Cigarette/Beedi Shop', 'Mysuru'],
        16: ['Street food vendors', 'Mysuru'],
        17: ['Restaurants / Dhabas/Café/Chains', 'Mysuru'],
        18: ['Juice / Coconut Water Vendors', 'Mysuru'],
        20: ['LPG/CNG/Gas/Fuel (Diesel/Petrol) Stations', 'Mysuru'],
        21: ['Car / Bike Workshops/Repair Shop', 'Mysuru'],
        23: [['Smartphone Retail shop /VI/Airtel/jio Stores','Cyber Cafes / Photocopy Shops','Smartphone Retail shop /VI/Airtel/jio Stores/Cyber Cafes / Photocopy Shops'],'Mysuru'],
        // 20: ['Cyber Cafes / Photocopy Shops', 'Mysuru'],
        26: ['Dairy', 'Mysuru'],
        28: ['Branded Clothing Store', 'Mysuru'],
        29: ['Men’s and women’s clothing shops', 'Mysuru'],
        30: ['Tailor shop', 'Mysuru'],
        32: [['Chemists / Medical Stores/Pathology Labs','Hospitals/Clinics / Doctors','Chemists / Medical Stores/Pathology Labs/Hospitals/Clinics / Doctors'], 'Mysuru'],
        35: ['Salons / Beauty Parlours/ Beauty and barber shops', 'Mysuru'],
        37: [['Auto Rickshaws/Bike Taxis/Cab Operators','Porter/Uber/Ola/Rapido','Travel/Railway/Metro/Bus','Auto Rickshaws/Bike Taxis/Cab Operators/ Porter / Uber / Ola / Rapido / Travel / Railway / Metro / Bus'], 'Mysuru'],
        41: [['Consumer Durables/Home Appliance/Electronic Stores (TV, Mixer, etc.)','Electrical/ Plumbing/Hardware Stores','Electronics Repair Shops/ Mobile Repair/Accessory Shops','Consumer Durables/Home Appliance Stores (TV, Mixer, etc.)/Electrical/ Plumbing/Hardware Stores/Electrical/ Plumbing/Hardware Stores'], 'Mysuru'],
        44: ['Beer, wine, liquor shop', 'Mysuru'],
       47: [['Premium Category Including Airport stores, Malls, Jewellery stores, educational institutions, hotel & lodging chains & standalones','Airport stores, Malls,Jewellery stores, educational institutions, hotel & lodging chains & standalones Jewellery stores, educational institutions, hotel & lodging chains & standalones'], 'Mysuru'],
       
      };
    
      Object.keys(criteriaMapMysuru).forEach(rowIndex => {
        const criteria = criteriaMapMysuru[rowIndex];
        const count = countMatches(criteria);
        const cellH = worksheet.getCell(`BP${rowIndex}`);
        cellH.value = count;
        if (rowIndex == 12 || rowIndex == 15 || rowIndex == 19 || rowIndex == 22 || rowIndex == 25 || rowIndex == 31 || rowIndex == 34 ||rowIndex == 36 || rowIndex == 40 ) {
          cellH.font = headerStyle.font
          cellH.fill = headerStyle.fill;
          cellH.alignment = headerStyle.alignment;
        cellH.border = headerStyle.border;
        }
        else{
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      }
      });

           const criteriaMapVijayawada = {
         4: ['Kirana/Grocery store', 'Vijayawada'],
        5: ['Fruit / Vegetable Vendors', 'Vijayawada'],
        6: ['Stationery / General Stores', 'Vijayawada'],
        7: ['Meat / Fish Shops', 'Vijayawada'],
        8: ['Sweet Shops/Mithai Shop', 'Vijayawada'],
        9: ['Ice Cream / Dessert Parlors', 'Vijayawada'],
        10: ['Departmental store/Supermarket/Walmart/Dmart', 'Vijayawada'],
        11: ['Bakery', 'Vijayawada', ],
        13: ['Tea/Coffee stall', 'Vijayawada'],
        14: ['Pan/Cigarette/Beedi Shop', 'Vijayawada'],
        16: ['Street food vendors', 'Vijayawada'],
        17: ['Restaurants / Dhabas/Café/Chains', 'Vijayawada'],
        18: ['Juice / Coconut Water Vendors', 'Vijayawada'],
        20: ['LPG/CNG/Gas/Fuel (Diesel/Petrol) Stations', 'Vijayawada'],
        21: ['Car / Bike Workshops/Repair Shop', 'Vijayawada'],
        23: [['Smartphone Retail shop /VI/Airtel/jio Stores','Cyber Cafes / Photocopy Shops','Smartphone Retail shop /VI/Airtel/jio Stores/Cyber Cafes / Photocopy Shops'],'Vijayawada'],
        // 20: ['Cyber Cafes / Photocopy Shops', 'Vijayawada'],
        26: ['Dairy', 'Vijayawada'],
       28: ['Branded Clothing Store', 'Vijayawada'],
        29: ['Men’s and women’s clothing shops', 'Vijayawada'],
        30: ['Tailor shop', 'Vijayawada'],
        32: [['Chemists / Medical Stores/Pathology Labs','Hospitals/Clinics / Doctors','Chemists / Medical Stores/Pathology Labs/Hospitals/Clinics / Doctors'], 'Vijayawada'],
        35: ['Salons / Beauty Parlours/ Beauty and barber shops', 'Vijayawada'],
       37: [['Auto Rickshaws/Bike Taxis/Cab Operators','Porter/Uber/Ola/Rapido','Travel/Railway/Metro/Bus','Auto Rickshaws/Bike Taxis/Cab Operators/ Porter / Uber / Ola / Rapido / Travel / Railway / Metro / Bus'], 'Vijayawada'],
        41: [['Consumer Durables/Home Appliance/Electronic Stores (TV, Mixer, etc.)','Electrical/ Plumbing/Hardware Stores','Electronics Repair Shops/ Mobile Repair/Accessory Shops','Consumer Durables/Home Appliance Stores (TV, Mixer, etc.)/Electrical/ Plumbing/Hardware Stores/Electrical/ Plumbing/Hardware Stores'], 'Vijayawada'],
        44: ['Beer, wine, liquor shop', 'Vijayawada'],
       47: [['Premium Category Including Airport stores, Malls, Jewellery stores, educational institutions, hotel & lodging chains & standalones','Airport stores, Malls,Jewellery stores, educational institutions, hotel & lodging chains & standalones Jewellery stores, educational institutions, hotel & lodging chains & standalones'], 'Vijayawada'],
       
      };
    
      Object.keys(criteriaMapVijayawada).forEach(rowIndex => {
        const criteria = criteriaMapVijayawada[rowIndex];
        const count = countMatches(criteria);
        const cellH = worksheet.getCell(`BS${rowIndex}`);
        cellH.value = count;
        if (rowIndex == 12 || rowIndex == 15 || rowIndex == 19 || rowIndex == 22 || rowIndex == 25 || rowIndex == 31 || rowIndex == 34 ||rowIndex == 36 || rowIndex == 40 ) {
          cellH.font = headerStyle.font
          cellH.fill = headerStyle.fill;
          cellH.alignment = headerStyle.alignment;
        cellH.border = headerStyle.border;
        }
        else{
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      }
      });

           const criteriaMapBhubaneswar = {
         4: ['Kirana/Grocery store', 'Bhubaneswar'],
        5: ['Fruit / Vegetable Vendors', 'Bhubaneswar'],
        6: ['Stationery / General Stores', 'Bhubaneswar'],
        7: ['Meat / Fish Shops', 'Bhubaneswar'],
        8: ['Sweet Shops/Mithai Shop', 'Bhubaneswar'],
        9: ['Ice Cream / Dessert Parlors', 'Bhubaneswar'],
        10: ['Departmental store/Supermarket/Walmart/Dmart', 'Bhubaneswar'],
        11: ['Bakery', 'Bhubaneswar', ],
        13: ['Tea/Coffee stall', 'Bhubaneswar'],
        14: ['Pan/Cigarette/Beedi Shop', 'Bhubaneswar'],
        16: ['Street food vendors', 'Bhubaneswar'],
        17: ['Restaurants / Dhabas/Café/Chains', 'Bhubaneswar'],
        18: ['Juice / Coconut Water Vendors', 'Bhubaneswar'],
        20: ['LPG/CNG/Gas/Fuel (Diesel/Petrol) Stations', 'Bhubaneswar'],
        21: ['Car / Bike Workshops/Repair Shop', 'Bhubaneswar'],
        23: [['Smartphone Retail shop /VI/Airtel/jio Stores','Cyber Cafes / Photocopy Shops','Smartphone Retail shop /VI/Airtel/jio Stores/Cyber Cafes / Photocopy Shops'],'Bhubaneswar'],
        // 20: ['Cyber Cafes / Photocopy Shops', 'Bhubaneswar'],
        26: ['Dairy', 'Bhubaneswar'],
        28: ['Branded Clothing Store', 'Bhubaneswar'],
        29: ['Men’s and women’s clothing shops', 'Bhubaneswar'],
        30: ['Tailor shop', 'Bhubaneswar'],
        32: [['Chemists / Medical Stores/Pathology Labs','Hospitals/Clinics / Doctors','Chemists / Medical Stores/Pathology Labs/Hospitals/Clinics / Doctors'], 'Bhubaneswar'],
        35: ['Salons / Beauty Parlours/ Beauty and barber shops', 'Bhubaneswar'],
        37: [['Auto Rickshaws/Bike Taxis/Cab Operators','Porter/Uber/Ola/Rapido','Travel/Railway/Metro/Bus','Auto Rickshaws/Bike Taxis/Cab Operators/ Porter / Uber / Ola / Rapido / Travel / Railway / Metro / Bus'], 'Bhubaneswar'],
        41: [['Consumer Durables/Home Appliance/Electronic Stores (TV, Mixer, etc.)','Electrical/ Plumbing/Hardware Stores','Electronics Repair Shops/ Mobile Repair/Accessory Shops','Consumer Durables/Home Appliance Stores (TV, Mixer, etc.)/Electrical/ Plumbing/Hardware Stores/Electrical/ Plumbing/Hardware Stores'], 'Bhubaneswar'],
        44: ['Beer, wine, liquor shop', 'Bhubaneswar'],
        47: [['Premium Category Including Airport stores, Malls, Jewellery stores, educational institutions, hotel & lodging chains & standalones','Airport stores, Malls,Jewellery stores, educational institutions, hotel & lodging chains & standalones Jewellery stores, educational institutions, hotel & lodging chains & standalones'], 'Bhubaneswar'],
       
      };
    
      Object.keys(criteriaMapBhubaneswar).forEach(rowIndex => {
        const criteria = criteriaMapBhubaneswar[rowIndex];
        const count = countMatches(criteria);
        const cellH = worksheet.getCell(`BV${rowIndex}`);
        cellH.value = count;
        if (rowIndex == 12 || rowIndex == 15 || rowIndex == 19 || rowIndex == 22 || rowIndex == 25 || rowIndex == 31 || rowIndex == 34 ||rowIndex == 36 || rowIndex == 40 ) {
          cellH.font = headerStyle.font
          cellH.fill = headerStyle.fill;
          cellH.alignment = headerStyle.alignment;
        cellH.border = headerStyle.border;
        }
        else{
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      }
      });

           const criteriaMapRanchi = {
       4: ['Kirana/Grocery store', 'Ranchi'],
        5: ['Fruit / Vegetable Vendors', 'Ranchi'],
        6: ['Stationery / General Stores', 'Ranchi'],
        7: ['Meat / Fish Shops', 'Ranchi'],
        8: ['Sweet Shops/Mithai Shop', 'Ranchi'],
        9: ['Ice Cream / Dessert Parlors', 'Ranchi'],
        10: ['Departmental store/Supermarket/Walmart/Dmart', 'Ranchi'],
        11: ['Bakery', 'Ranchi', ],
        13: ['Tea/Coffee stall', 'Ranchi'],
        14: ['Pan/Cigarette/Beedi Shop', 'Ranchi'],
        16: ['Street food vendors', 'Ranchi'],
        17: ['Restaurants / Dhabas/Café/Chains', 'Ranchi'],
        18: ['Juice / Coconut Water Vendors', 'Ranchi'],
        20: ['LPG/CNG/Gas/Fuel (Diesel/Petrol) Stations', 'Ranchi'],
        21: ['Car / Bike Workshops/Repair Shop', 'Ranchi'],
        23: [['Smartphone Retail shop /VI/Airtel/jio Stores','Cyber Cafes / Photocopy Shops','Smartphone Retail shop /VI/Airtel/jio Stores/Cyber Cafes / Photocopy Shops'],'Ranchi'],
        // 20: ['Cyber Cafes / Photocopy Shops', 'Ranchi'],
        26: ['Dairy', 'Ranchi'],
        28: ['Branded Clothing Store', 'Ranchi'],
        29: ['Men’s and women’s clothing shops', 'Ranchi'],
        30: ['Tailor shop', 'Ranchi'],
        32: [['Chemists / Medical Stores/Pathology Labs','Hospitals/Clinics / Doctors','Chemists / Medical Stores/Pathology Labs/Hospitals/Clinics / Doctors'], 'Ranchi'],
        35: ['Salons / Beauty Parlours/ Beauty and barber shops', 'Ranchi'],
        37: [['Auto Rickshaws/Bike Taxis/Cab Operators','Porter/Uber/Ola/Rapido','Travel/Railway/Metro/Bus','Auto Rickshaws/Bike Taxis/Cab Operators/ Porter / Uber / Ola / Rapido / Travel / Railway / Metro / Bus'], 'Ranchi'],
        41: [['Consumer Durables/Home Appliance/Electronic Stores (TV, Mixer, etc.)','Electrical/ Plumbing/Hardware Stores','Electronics Repair Shops/ Mobile Repair/Accessory Shops','Consumer Durables/Home Appliance Stores (TV, Mixer, etc.)/Electrical/ Plumbing/Hardware Stores/Electrical/ Plumbing/Hardware Stores'], 'Ranchi'],
        44: ['Beer, wine, liquor shop', 'Ranchi'],
        47: [['Premium Category Including Airport stores, Malls, Jewellery stores, educational institutions, hotel & lodging chains & standalones','Airport stores, Malls,Jewellery stores, educational institutions, hotel & lodging chains & standalones Jewellery stores, educational institutions, hotel & lodging chains & standalones'], 'Ranchi'],
       
      };
    
      Object.keys(criteriaMapRanchi).forEach(rowIndex => {
        const criteria = criteriaMapRanchi[rowIndex];
        const count = countMatches(criteria);
        const cellH = worksheet.getCell(`BY${rowIndex}`);
        cellH.value = count;
         if (rowIndex == 12 || rowIndex == 15 || rowIndex == 19 || rowIndex == 22 || rowIndex == 25 || rowIndex == 31 || rowIndex == 34 ||rowIndex == 36 || rowIndex == 40 ) {
          cellH.font = headerStyle.font
          cellH.fill = headerStyle.fill;
          cellH.alignment = headerStyle.alignment;
        cellH.border = headerStyle.border;
        }
        else{
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      }
      });

           const criteriaMapPanaji = {
        4: ['Kirana/Grocery store', 'Panaji'],
        5: ['Fruit / Vegetable Vendors', 'Panaji'],
        6: ['Stationery / General Stores', 'Panaji'],
        7: ['Meat / Fish Shops', 'Panaji'],
        8: ['Sweet Shops/Mithai Shop', 'Panaji'],
        9: ['Ice Cream / Dessert Parlors', 'Panaji'],
        10: ['Departmental store/Supermarket/Walmart/Dmart', 'Panaji'],
        11: ['Bakery', 'Panaji', ],
        13: ['Tea/Coffee stall', 'Panaji'],
        14: ['Pan/Cigarette/Beedi Shop', 'Panaji'],
        16: ['Street food vendors', 'Panaji'],
        17: ['Restaurants / Dhabas/Café/Chains', 'Panaji'],
        18: ['Juice / Coconut Water Vendors', 'Panaji'],
        20: ['LPG/CNG/Gas/Fuel (Diesel/Petrol) Stations', 'Panaji'],
        21: ['Car / Bike Workshops/Repair Shop', 'Panaji'],
        23: [['Smartphone Retail shop /VI/Airtel/jio Stores','Cyber Cafes / Photocopy Shops','Smartphone Retail shop /VI/Airtel/jio Stores/Cyber Cafes / Photocopy Shops'],'Panaji'],
        // 20: ['Cyber Cafes / Photocopy Shops', 'Panaji'],
       26: ['Dairy', 'Panaji'],
        28: ['Branded Clothing Store', 'Panaji'],
        29: ['Men’s and women’s clothing shops', 'Panaji'],
        30: ['Tailor shop', 'Panaji'],
        32: [['Chemists / Medical Stores/Pathology Labs','Hospitals/Clinics / Doctors','Chemists / Medical Stores/Pathology Labs/Hospitals/Clinics / Doctors'], 'Panaji'],
        35: ['Salons / Beauty Parlours/ Beauty and barber shops', 'Panaji'],
        37: [['Auto Rickshaws/Bike Taxis/Cab Operators','Porter/Uber/Ola/Rapido','Travel/Railway/Metro/Bus','Auto Rickshaws/Bike Taxis/Cab Operators/ Porter / Uber / Ola / Rapido / Travel / Railway / Metro / Bus'], 'Panaji'],
        41: [['Consumer Durables/Home Appliance/Electronic Stores (TV, Mixer, etc.)','Electrical/ Plumbing/Hardware Stores','Electronics Repair Shops/ Mobile Repair/Accessory Shops','Consumer Durables/Home Appliance Stores (TV, Mixer, etc.)/Electrical/ Plumbing/Hardware Stores/Electrical/ Plumbing/Hardware Stores'], 'Panaji'],
        44: ['Beer, wine, liquor shop', 'Panaji'],
       47: [['Premium Category Including Airport stores, Malls, Jewellery stores, educational institutions, hotel & lodging chains & standalones','Airport stores, Malls,Jewellery stores, educational institutions, hotel & lodging chains & standalones Jewellery stores, educational institutions, hotel & lodging chains & standalones'], 'Panaji'],
       
      };
    
      Object.keys(criteriaMapPanaji).forEach(rowIndex => {
        const criteria = criteriaMapPanaji[rowIndex];
        const count = countMatches(criteria);
        const cellH = worksheet.getCell(`CB${rowIndex}`);
        cellH.value = count;
        if (rowIndex == 12 || rowIndex == 15 || rowIndex == 19 || rowIndex == 22 || rowIndex == 25 || rowIndex == 31 || rowIndex == 34 ||rowIndex == 36 || rowIndex == 40 ) {
          cellH.font = headerStyle.font
          cellH.fill = headerStyle.fill;
          cellH.alignment = headerStyle.alignment;
        cellH.border = headerStyle.border;
        }
        else{
        cellH.font = cellStyle.font;
        cellH.fill = achievedcellstyle.fill;
        cellH.alignment = cellStyle.alignment;
        cellH.border = cellStyle.border;
      }
      });


       // TOTAL  ACHIVED VALUES IN D 
      for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
        const cellC = worksheet.getCell(`C${rowIndex}`);
        if (cellC.value && datatowrite.includes(cellC.value)) {
          const sum = ['H','K','N','Q','T','W','Z','AC','AF','AI','AL','AO','AR','AU','AX','BA','BD','BG','BJ','BM','BP','BS','BV','BY','CB']
            .map(col => worksheet.getCell(`${col}${rowIndex}`).value || 0)
            .reduce((acc, value) => acc + value, 0);
  
          const cellE = worksheet.getCell(`E${rowIndex}`);
          cellE.value = sum;
           if (rowIndex == 12 || rowIndex == 15 || rowIndex == 19 || rowIndex == 22 || rowIndex == 25 || rowIndex == 27 || rowIndex == 31 || rowIndex == 34 ||rowIndex == 36 || rowIndex == 40 ) {
          cellE.font = headerStyle.font
          cellE.fill = headerStyle.fill;
          cellE.alignment = headerStyle.alignment;
        cellE.border = headerStyle.border;
        }
          else {
            cellE.font = cellStyle.font;
  
            cellE.fill = achievedcellstyle.fill;
          }
  
          cellE.alignment = cellStyle.alignment;
          cellE.border = cellStyle.border;
        }
      }
  // TOTAL PENDING VALUES





    const calculateAndSetSum = (columnLetter, sumRange, targetRow) => {
        let sum = 0;
        console.log(`Calculating sum for column ${columnLetter}, rows ${sumRange.start}-${sumRange.end}, excluding: ${excludeRows.join(', ')}`);
        for (let rowIndex = sumRange.start; rowIndex <= sumRange.end; rowIndex++) {
          // Skip rows that don't have criteria defined
          if (excludeRows.includes(rowIndex)) {
            console.log(`Skipping row ${rowIndex} (excluded)`);
            continue;
          }
          const cellValue = worksheet.getCell(`${columnLetter}${rowIndex}`).value || 0;
          sum += cellValue;
          console.log(`Row ${rowIndex}: ${cellValue}, Running sum: ${sum}`);
        }
        console.log(`Final sum for ${columnLetter}${targetRow}: ${sum}`);
         if (targetRow == 12 || targetRow == 15 || targetRow == 19 || targetRow == 22 || targetRow == 25 ||targetRow == 27 || targetRow == 31 || targetRow == 34 || targetRow == 36 || targetRow == 38 || targetRow == 39 || targetRow == 40 ) {
         worksheet.getCell(`${columnLetter}${targetRow}`).value = sum;
        worksheet.getCell(`${columnLetter}${targetRow}`).font = headerStyle.font;
        worksheet.getCell(`${columnLetter}${targetRow}`).fill = headerStyle.fill;
        worksheet.getCell(`${columnLetter}${targetRow}`).alignment = headerStyle.alignment;
        worksheet.getCell(`${columnLetter}${targetRow}`).border = headerStyle.border;
        }
        else{
        worksheet.getCell(`${columnLetter}${targetRow}`).value = sum;
        worksheet.getCell(`${columnLetter}${targetRow}`).font = headerStyle.font;
        worksheet.getCell(`${columnLetter}${targetRow}`).fill = achievedcellstyle.fill;
        worksheet.getCell(`${columnLetter}${targetRow}`).alignment = cellStyle.alignment;
        worksheet.getCell(`${columnLetter}${targetRow}`).border = cellStyle.border;
        }
      };
  
    //   Define the range of rows to sum (rows 4 to 39, excluding missing rows)
      const sumRowRange = { start: 4, end: 48 };
      // Define rows to exclude from sum (rows that don't have criteria defined)
      const excludeRows = [12,15,19,22,24,25,27,31, 32, 34,36,38,39,40,42, 43, 45, 46, 48];
      
  
      
      const columnsToSum = ['E', 'H','K','N','Q','T','W','Z','AC','AF','AI','AL','AO','AR','AU','AX','BA','BD','BG','BJ','BM','BP','BS','BV','BY','CB']
  
      
      columnsToSum.forEach(column => {
        calculateAndSetSum(column, sumRowRange, 50); 
      });

    

     

      const columnsFinal = [
        { result: 'F', from: 'D', subtract: 'E' },
        { result: 'I', from: 'G', subtract: 'H' },
        { result: 'L', from: 'J', subtract: 'K' },
        { result: 'O', from: 'M', subtract: 'N' },
        { result: 'R', from: 'P', subtract: 'Q' },
        { result: 'U', from: 'S', subtract: 'T' },
        { result: 'X', from: 'V', subtract: 'W' },
        { result: 'AA', from: 'Y', subtract: 'Z' },
        { result: 'AD', from: 'AB', subtract: 'AC' },
        { result: 'AG', from: 'AE', subtract: 'AF' },
        { result: 'AJ', from: 'AH', subtract: 'AI' },
        { result: 'AM', from: 'AK', subtract: 'AL' },
        { result: 'AP', from: 'AN', subtract: 'AO' },
        { result: 'AS', from: 'AQ', subtract: 'AR' },
        { result: 'AV', from: 'AT', subtract: 'AU' },
        { result: 'AY', from: 'AW', subtract: 'AX' },
        { result: 'BB', from: 'AZ', subtract: 'BA' },
        { result: 'BE', from: 'BC', subtract: 'BD' },
        { result: 'BH', from: 'BF', subtract: 'BG' },
        { result: 'BK', from: 'BI', subtract: 'BJ' },
        { result: 'BN', from: 'BL', subtract: 'BM' },
        { result: 'BQ', from: 'BO', subtract: 'BP' },
        { result: 'BT', from: 'BR', subtract: 'BS' },
        { result: 'BW', from: 'BU', subtract: 'BV' },
        { result: 'BZ', from: 'BX', subtract: 'BY' },
        { result: 'CC', from: 'CA', subtract: 'CB' },
        
       
      ];
  
columnsFinal.forEach(({ result, from, subtract }) => {
  for (let rowIndex = 4; rowIndex <= worksheet.rowCount; rowIndex++) {
    // Skip rows 20 and 26 entirely
    if (rowIndex === 12 ||  rowIndex === 15 || rowIndex === 19 ||rowIndex === 22 || rowIndex === 25  ||  rowIndex === 24 || rowIndex === 27 ||rowIndex === 31 || rowIndex === 32 ||rowIndex === 34  || rowIndex === 36 || rowIndex === 38 || rowIndex === 39 || rowIndex === 40 || rowIndex === 41 || rowIndex === 42 || rowIndex === 44 || rowIndex === 45 || rowIndex === 47 || rowIndex === 48) continue;

    const cellFrom = worksheet.getCell(`${from}${rowIndex}`);
    const cellSubtract = worksheet.getCell(`${subtract}${rowIndex}`);
    const cellToFill = worksheet.getCell(`${result}${rowIndex}`);

    const valueFrom = cellFrom.value || 0;
    const valueSubtract = cellSubtract.value || 0;
    cellToFill.value = valueFrom - valueSubtract;

    if (rowIndex === 50) {
      cellToFill.font = headerStyle.font;
      cellToFill.fill = cellStyle.fill;
    } else {
      cellToFill.font = cellStyle.font;
      cellToFill.fill = pendingcellstyle.fill;
    }

    cellToFill.alignment = cellStyle.alignment;
    cellToFill.border = cellStyle.border;
  }
});


  
  
const sumRowRangerow12 = { start: 4, end: 11 };
    
      const columnsToSumrow12 = ['D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','AA','AB','AC','AD','AE','AF','AG','AH','AI','AJ','AK','AL','AM','AN','AO','AP','AQ','AR','AS','AT','AU','AV','AW','AX','AY','AZ','BA','BB','BC','BD','BE','BF','BG','BH','BI','BJ','BK','BL','BM','BN','BO','BP','BQ','BR','BS','BT','BU','BV','BW','BX','BY','BZ','CA','CB','CC']
  
      
      columnsToSumrow12.forEach(column => {
        calculateAndSetSum(column, sumRowRangerow12, 12); 
      });


  
      const sumRowRangerow15 = { start: 13, end: 14 };
    
      const columnsToSumrow15 = ['D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','AA','AB','AC','AD','AE','AF','AG','AH','AI','AJ','AK','AL','AM','AN','AO','AP','AQ','AR','AS','AT','AU','AV','AW','AX','AY','AZ','BA','BB','BC','BD','BE','BF','BG','BH','BI','BJ','BK','BL','BM','BN','BO','BP','BQ','BR','BS','BT','BU','BV','BW','BX','BY','BZ','CA','CB','CC']
  
      
      columnsToSumrow15.forEach(column => {
        calculateAndSetSum(column, sumRowRangerow15, 15); 
      });

       const sumRowRangerow19 = { start: 16, end: 18 };
    
      const columnsToSumrow19 = ['D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','AA','AB','AC','AD','AE','AF','AG','AH','AI','AJ','AK','AL','AM','AN','AO','AP','AQ','AR','AS','AT','AU','AV','AW','AX','AY','AZ','BA','BB','BC','BD','BE','BF','BG','BH','BI','BJ','BK','BL','BM','BN','BO','BP','BQ','BR','BS','BT','BU','BV','BW','BX','BY','BZ','CA','CB','CC']
  
      
      columnsToSumrow19.forEach(column => {
        calculateAndSetSum(column, sumRowRangerow19, 19); 
      });

       const sumRowRangerow22 = { start: 20, end: 21 };
    
      const columnsToSumrow22 = ['D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','AA','AB','AC','AD','AE','AF','AG','AH','AI','AJ','AK','AL','AM','AN','AO','AP','AQ','AR','AS','AT','AU','AV','AW','AX','AY','AZ','BA','BB','BC','BD','BE','BF','BG','BH','BI','BJ','BK','BL','BM','BN','BO','BP','BQ','BR','BS','BT','BU','BV','BW','BX','BY','BZ','CA','CB','CC']
  
      
      columnsToSumrow22.forEach(column => {
        calculateAndSetSum(column, sumRowRangerow22, 22); 
      });
  
      const sumRowRangerow25 = { start: 23, end: 24 };
    
      const columnsToSumrow25 = [ 'D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','AA','AB','AC','AD','AE','AF','AG','AH','AI','AJ','AK','AL','AM','AN','AO','AP','AQ','AR','AS','AT','AU','AV','AW','AX','AY','AZ','BA','BB','BC','BD','BE','BF','BG','BH','BI','BJ','BK','BL','BM','BN','BO','BP','BQ','BR','BS','BT','BU','BV','BW','BX','BY','BZ','CA','CB','CC']
  
      
      columnsToSumrow25.forEach(column => {
        calculateAndSetSum(column, sumRowRangerow25, 25); 
      });

      const sumRowRangerow27 = { start: 26, end: 26 };
    
      const columnsToSumrow27 = ['D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','AA','AB','AC','AD','AE','AF','AG','AH','AI','AJ','AK','AL','AM','AN','AO','AP','AQ','AR','AS','AT','AU','AV','AW','AX','AY','AZ','BA','BB','BC','BD','BE','BF','BG','BH','BI','BJ','BK','BL','BM','BN','BO','BP','BQ','BR','BS','BT','BU','BV','BW','BX','BY','BZ','CA','CB','CC']
  
      
      columnsToSumrow27.forEach(column => {
        calculateAndSetSum(column, sumRowRangerow27, 27); 
      });

      const sumRowRangerow31 = { start: 28, end: 30 };
    
      const columnsToSumrow31 = [ 'D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','AA','AB','AC','AD','AE','AF','AG','AH','AI','AJ','AK','AL','AM','AN','AO','AP','AQ','AR','AS','AT','AU','AV','AW','AX','AY','AZ','BA','BB','BC','BD','BE','BF','BG','BH','BI','BJ','BK','BL','BM','BN','BO','BP','BQ','BR','BS','BT','BU','BV','BW','BX','BY','BZ','CA','CB','CC']
  
      
      columnsToSumrow31.forEach(column => {
        calculateAndSetSum(column, sumRowRangerow31, 31); 
      });

      const sumRowRangerow34 = { start: 32, end: 33 };
    
      const columnsToSumrow34 = [ 'D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','AA','AB','AC','AD','AE','AF','AG','AH','AI','AJ','AK','AL','AM','AN','AO','AP','AQ','AR','AS','AT','AU','AV','AW','AX','AY','AZ','BA','BB','BC','BD','BE','BF','BG','BH','BI','BJ','BK','BL','BM','BN','BO','BP','BQ','BR','BS','BT','BU','BV','BW','BX','BY','BZ','CA','CB','CC']
  
      
      columnsToSumrow34.forEach(column => {
        calculateAndSetSum(column, sumRowRangerow34, 34); 
      });

const sumRowRangerow36 = { start: 35, end: 35 };
    
      const columnsToSumrow36 = ['D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','AA','AB','AC','AD','AE','AF','AG','AH','AI','AJ','AK','AL','AM','AN','AO','AP','AQ','AR','AS','AT','AU','AV','AW','AX','AY','AZ','BA','BB','BC','BD','BE','BF','BG','BH','BI','BJ','BK','BL','BM','BN','BO','BP','BQ','BR','BS','BT','BU','BV','BW','BX','BY','BZ','CA','CB','CC']
  
      
      columnsToSumrow36.forEach(column => {
        calculateAndSetSum(column, sumRowRangerow36, 36); 
      });

      const sumRowRangerow40 = { start: 37, end: 37 };
    
      const columnsToSumrow40 = [ 'D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','AA','AB','AC','AD','AE','AF','AG','AH','AI','AJ','AK','AL','AM','AN','AO','AP','AQ','AR','AS','AT','AU','AV','AW','AX','AY','AZ','BA','BB','BC','BD','BE','BF','BG','BH','BI','BJ','BK','BL','BM','BN','BO','BP','BQ','BR','BS','BT','BU','BV','BW','BX','BY','BZ','CA','CB','CC']
  
      
      columnsToSumrow40.forEach(column => {
        calculateAndSetSum(column, sumRowRangerow40, 40); 
      });
  


  if (id?.id == "688716b052a839aadb5234ca") {
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/octet-stream' });
      saveAs(blob, 'QCC.xlsx');
      setLoader(false);
    }
   

  };
 


  return (
    <>
      {loader && <Loader />}
      <div className="excelcontainer">
        <div className="excelcard">
<label>Select Date </label>
        <input
                type="date"
                className='form-control'
                value={selectedDate}
                onChange={handleDateChange}
                style={{ marginBottom: '10px', padding: '5px' }}
            />
          
          {id?.id == "688716b052a839aadb5234ca" &&
            <> <label> Qcc </label>
              <button className="btn btn-primary" onClick={() => handleDownloadRupay()}>Download</button>
            </>}
          <br />
          
  <br />
        
        </div>

      </div>
    </>
  );
};

export default QuotaSheet;


  
  
  